import { inject, observer } from "mobx-react";
import AgGrid from "../../../common/components/ag-grid/ag-grid";
import { AppConstants, Types } from "../../../common/APIConstants";
import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import WindowedSelect from "react-windowed-select";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import moment from "moment";
import CheckboxRenderer from "../../../common/CheckboxRenderer";
import SmartSelect from "../../../common/SmartSelect";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import RestEndPoint from '../../../common/RestEndPoint';
import { confirmAlert } from 'react-confirm-alert';
import { Modal, Button, Container } from 'react-bootstrap';
import { DateTimeFormatter } from '../../../common/DateFormatterWithZone';
import { BooleanTextFormatter } from '../../../common/BooleanFormatter';
import {
  faFileExport, faPlus, faSave,
  faSync, faEye, faAsterisk, faChartBar
} from "@fortawesome/free-solid-svg-icons";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import outageScheduleReportStore from "../store/outage-schedule-report-store";
import userRoles from '../../../constants/userRoles';

import { sortBy, toUpper, uniq, uniqBy } from "lodash";
import { PrevCommentsModal } from "./PrevCommentsModal";
import { CustomSelect } from "./CustomSelect";
import { PinId } from "./PinId";
import { getDateInCSTOrMST, getAllUniqAssetsFilterByRegionDivisionAndDistrict, getAllUniqDistrictsFilterByRegionAndDivision, getAllUniqDivisionsFilterByRegion, getAllUniqAssets, getAllUniqDistricts, getAllUniqDivisions, getCorrespondingResources, getDateTimeWithoutUTCOffset, getRegionBasedDateTime, sortResources } from "../utils";
import { CustomSelectErrorMessage } from "./CustomSelectErrorMessage";
import {DateFormatter} from './DateFormatter'
import { 
  HISTORICAL_TABLE_COMMENTS, 
  HISTORICAL_TABLE_OPS_MITIGATION_PLAN, 
  HISTORICAL_TABLE_SCHEDULING_MITIGATION_PLAN 
} from "../constants/outage-schedule-report";

import '../component/outage-schedule-report-component.scss';

@inject("OutageScheduleReportStore", "AuthStore", "CommonStore")
@observer
class OutageScheduleReport extends React.Component {
  constructor(props) {
    super(props);
      var _isLinkUrl = this.props.computedMatch.params.profile;
    this.state = {
      regions: [
        { label: 'Plains - South', value: 'Plains - South' },
        { label: 'Plains - North', value: 'Plains - North' }
      ],
      divisions: [], districts: [], assets: [],
      selectedRegnOption: [
        { label: 'All', value: '*' },
        { label: 'Plains - South', value: 'Plains - South' },
        { label: 'Plains - North', value: 'Plains - North' }
      ],
        selectedDivOptions: [], selectedDistOptions: [], selectedAstOptions: [],
      gridRowdata: [],
      selectedRegnFrm: null,
      // TODO: Remove this var
      selectedDivFrm: { label: '---', value: '' },
      // TODO: Remove this var
      selectedDistFrm: { label: '---', value: '' },
      // TODO: Remove this var
      selectedAstFrm: { label: '---', value: '' },
      lastAckBy: null,
      primaryContactSuggestions: [],
      secondaryContactSuggestions: [],
        isViewMode: false,
        isInitialLoadArray: true,
      isAcknowledgerRole: false,
      showCommentsModel: false,
      showAckModel: false,
      previousAcknowledgement: '',
      isDirectRoute: _isLinkUrl ? true : false,
      isSameGroupUserRole: true,
      isReadOnlyRoleUser: false,
      isAddMode: true,
      editRowData: '',
      isFormVisible: false,
      formRowData: [],
      rowSelected: false,
      StartDate: null,
      EndDate: null,
      show30DaysView: false,
      show60DaysView: false,
      show180DaysView: false,
      showCompletedView: false,
      showDiscontinuedView: false,
      OPIAndOPIMPEnabled: false,
      SCIAndSCIMPEnabled: false,
      showSchedulingModal: false,
      showOperationsModal: false,
      isUserFromOps: false,
      isRowDoubleClicked: false,
      gridOptions: {
        onRowDoubleClicked: this.onRowDoubleClicked,
        suppressClickEdit: true,
        pagination: false,
        stopEditingWhenGridLosesFocus: true,
        autoSizeAllColumns: true,
        floatingFilter: true,
        headerHeight: 40,
        enableRangeSelection: true,
        rowSelection: "single",
        rowGroupPanelShow: "always",
        suppressContextMenu: true,
        statusBar: {
          statusPanels: [
            {
              statusPanel: "agTotalAndFilteredRowCountComponent",
              align: "left",
            },
            {
              statusPanel: "agAggregationComponent",
              statusPanelParams: {
                aggFuncs: ["avg", "count", "min", "max", "sum"],
              },
            },
          ],
        },
        sideBar: {
          toolPanels: [
            {
              id: "columns", labelDefault: "Columns", labelKey: "columns",
              iconKey: "columns", toolPanel: "agColumnsToolPanel",
            }
          ],
          showToolPanel: false,
        },
        defaultColDef: {
          enableRowGroup: true, enablePivot: true, enableValue: true,
          sortable: true, filter: true, resizable: true,
        },
        frameworkComponents: {
          dateTimeFormatter: DateTimeFormatter, dateFormatter: DateFormatter,
          SmartSelect: SmartSelect, booleanCellEditor: CheckboxRenderer, booleanTextFormatter: BooleanTextFormatter,
          PinId: PinId
        },
      },
    };
  }
    handleRegnSelect = async (val, e) => {
        this.setState({ isInitialLoadArray: false })
    let resources = {
      selectedRegn: {value: '*', label: 'All'},
      selectedDiv: null,
      selectedDist: null
    }
    const dropdownFlag = 'Region'
    if (e.action === "select-option" && e.option.value === "*") {
      const {divs, dists, assets} = getCorrespondingResources(this.getGridMainData(), resources, dropdownFlag)
      this.setState({
        selectedRegnOption: [{ label: "All", value: "*" }, ...this.state.regions],
        selectedDivOptions: [{ label: "All", value: "*" }, ...divs],
        selectedDistOptions: [{ label: "All", value: "*" }, ...dists],
        selectedAstOptions: [{ label: "All", value: "*" }, ...assets],
        divisions: [...divs],
        districts: [...dists],
        assets: [...assets]
      });
    } else if (e.action === "deselect-option" && e.option.value === "*") {
      this.setState({
        selectedRegnOption: [],
        selectedDivOptions: [],
        selectedDistOptions: [],
        selectedAstOptions: []
      });
    } else if (e.action === "deselect-option") {
      let selectedRegionOption = val.filter((o) => o.value !== "*")
      resources.selectedRegn = selectedRegionOption
      const {divs, dists, assets} = getCorrespondingResources(this.getGridMainData(), resources, dropdownFlag)
      this.setState({
        selectedRegnOption: val.filter((o) => o.value !== "*"),
        selectedDivOptions: [{ label: "All", value: "*" }, ...divs],
        selectedDistOptions: [{ label: "All", value: "*" }, ...dists],
        selectedAstOptions: [{ label: "All", value: "*" }, ...assets],
        divisions: [...divs],
        districts: [...dists],
        assets: [...assets]
      });
    } else if (val.length === this.state.regions.length) {
      resources.selectedRegn = this.state.regions
      const {divs, dists, assets} = getCorrespondingResources(this.getGridMainData(), resources, dropdownFlag)
      this.setState({
        selectedRegnOption: [{ label: "All", value: "*" }, ...this.state.regions],
        selectedDivOptions: [{ label: "All", value: "*" }, ...divs],
        selectedDistOptions: [{ label: "All", value: "*" }, ...dists],
        selectedAstOptions: [{ label: "All", value: "*" }, ...assets],
        divisions: [...divs],
        districts: [...dists],
        assets: [...assets]
      });
    } else {
      resources.selectedRegn = val
      const {divs, dists, assets} = getCorrespondingResources(this.getGridMainData(), resources, dropdownFlag)
      this.setState({
        selectedRegnOption: val,
        selectedDivOptions: [{ label: "All", value: "*" }, ...divs],
        selectedDistOptions: [{ label: "All", value: "*" }, ...dists],
        selectedAstOptions: [{ label: "All", value: "*" }, ...assets],
        divisions: [...divs],
        districts: [...dists],
        assets: [...assets]
      });
    }
  }
    handleDivSelect = async (val, e) => {
        this.setState({ isInitialLoadArray: false })
    const resources = {
      selectedRegn: this.state.selectedRegnOption,
      selectedDiv: {value: '*', label: 'All'},
      selectedDist: this.state.selectedDistOption
      }
    const dropdownFlag = 'Division'
    if (e.action === "select-option" && e.option.value === "*") {
      const {dists, assets} = getCorrespondingResources(this.getGridMainData(), resources, dropdownFlag)
      this.setState({
          selectedDivOptions: [{ label: "All", value: "*" }, ...this.state.divisions],
        selectedDistOptions: [{ label: "All", value: "*" }, ...dists],
        selectedAstOptions: [{ label: "All", value: "*" }, ...assets],
        districts: [...dists],
        assets: [...assets]
      });
    } else if (e.action === "deselect-option" && e.option.value === "*") {
      this.setState({
        selectedDivOptions: [],
        selectedDistOptions: [],
        selectedAstOptions: []
      });
    } else if (e.action === "deselect-option") {
      let selectedDivOptions = val.filter((o) => o.value !== "*")
      resources.selectedDiv = selectedDivOptions
      resources.selectedRegn = this.state.regions
      const {dists, assets} = getCorrespondingResources(this.getGridMainData(), resources, dropdownFlag)
      this.setState({
        selectedDivOptions: val.filter((o) => o.value !== "*"),
        selectedDistOptions: [{ label: "All", value: "*" }, ...dists],
        selectedAstOptions: [{ label: "All", value: "*" }, ...assets],
        districts: [...dists],
        assets: [...assets]
      });
    } else if (val.length === this.state.divisions.length) {
      resources.selectedRegn = this.state.regions
      const {dists, assets} = getCorrespondingResources(this.getGridMainData(), resources, dropdownFlag)
      this.setState({
        selectedDivOptions: [{ label: "All", value: "*" }, ...this.state.divisions],
        selectedDistOptions: [{ label: "All", value: "*" }, ...dists],
        selectedAstOptions: [{ label: "All", value: "*" }, ...assets],
        districts: [...dists],
        assets: [...assets]
      });
    } else {
      resources.selectedRegn = this.state.selectedRegnOption
      resources.selectedDiv = val
      const {dists, assets} = getCorrespondingResources(this.getGridMainData(), resources, dropdownFlag)
      this.setState({
        selectedDivOptions: val,
        selectedDistOptions: [{ label: "All", value: "*" }, ...dists],
        selectedAstOptions: [{ label: "All", value: "*" }, ...assets],
        districts: [...dists],
        assets: [...assets]
      });
    }
  }
    handleDistSelect = async (val, e) => {
        this.setState({ isInitialLoadArray: false })
    const resources = {
      selectedRegn: this.state.selectedRegnOption,
      selectedDiv: this.state.selectedDivOptions,
      selectedDist: {value: '*', label: 'All'}
      }
    const dropdownFlag = 'District'
    if (e.action === "select-option" && e.option.value === "*") {
      const {assets} = getCorrespondingResources(this.getGridMainData(), resources, dropdownFlag)
      this.setState({
        selectedDistOptions: [{ label: "All", value: "*" }, ...this.state.districts],
        selectedAstOptions: [{ label: "All", value: "*" }, ...assets],
        assets: [...assets]
      });
    } else if (e.action === "deselect-option" && e.option.value === "*") {
      this.setState({
        selectedDistOptions: [],
        selectedAstOptions: []
      });
    } else if (e.action === "deselect-option") {
      let selectedDistOptions = val.filter((o) => o.value !== "*")
      resources.selectedDist = selectedDistOptions
      //resources.selectedRegn = this.state.regions
      //resources.selectedDiv = this.state.divisions
      const {assets} = getCorrespondingResources(this.getGridMainData(), resources, dropdownFlag)
      this.setState({
        selectedDistOptions: val.filter((o) => o.value !== "*"),
        selectedAstOptions: [{ label: "All", value: "*" }, ...assets],
        assets: [...assets]
      });
    } else if (val.length === this.state.districts.length) {
      resources.selectedRegn = this.state.regions
      resources.selectedDiv = this.state.divisions
      resources.selectedDist = this.state.districts
      const {assets} = getCorrespondingResources(this.getGridMainData(), resources, dropdownFlag)
      this.setState({
        selectedDistOptions: [{ label: "All", value: "*" }, ...this.state.districts],
        selectedAstOptions: [{ label: "All", value: "*" }, ...assets],
        assets: [...assets]
      });
    } else {
      resources.selectedRegn = this.state.selectedRegnOption
      resources.selectedDiv = this.state.selectedDivOptions
      resources.selectedDist = val
      const {assets} = getCorrespondingResources(this.getGridMainData(), resources, dropdownFlag)
      this.setState({
        selectedDistOptions: val,
        selectedAstOptions: [{ label: "All", value: "*" }, ...assets],
        assets: [...assets]
      });
    }
  }
    handleAstSelect = async (val, e) => {
        this.setState({ isInitialLoadArray: false })
    if (e.action === "select-option" && e.option.value === "*") {
      this.setState({
        selectedAstOptions: [{ label: "All", value: "*" }, ...this.state.assets]
      });
    } else if (e.action === "deselect-option" && e.option.value === "*") {
      this.setState({
        selectedAstOptions: []
      });
    } else if (e.action === "deselect-option") {
      this.setState({
        selectedAstOptions: val.filter((o) => o.value !== "*")
      });
    } else if (val.length === this.state.assets.length) {
      this.setState({
        selectedAstOptions: [{ label: "All", value: "*" }, ...this.state.assets]
      });
    } else {
      this.setState({
        selectedAstOptions: val
      });
    }
  }
    addNewRow = async (e) => {
    const { OutageScheduleReportStore } = this.props;

    const loggedinUser = OutageScheduleReportStore.loggedUserData;
    let isCurrUserFromAssetLogistics = false
    let isCurrentUserFormConstrolCenterOrOps = false
    let isUserFromOps = false

    if (loggedinUser?.length) {
      isCurrUserFromAssetLogistics = loggedinUser[0].GroupNm === userRoles.OUTAGESCHEDULING
      isCurrentUserFormConstrolCenterOrOps = loggedinUser[0].GroupNm === userRoles.OUTAGEOPSROLE ||
        loggedinUser[0].GroupNm === userRoles.OutageControlCenter
      isUserFromOps = loggedinUser[0].GroupNm === userRoles.OUTAGEOPSROLE
    }

    this.setState({ filterModel: this.state.gridOptions.api.getFilterModel(), sortModel: this.state.gridOptions.api.getSortModel() });
    this.setState({
      isFormVisible: true,
      formRowData: null,
      isAddMode: true,
      isSameGroupUserRole: true,
      isViewMode: false,
      OPIAndOPIMPEnabled: isCurrentUserFormConstrolCenterOrOps,
      SCIAndSCIMPEnabled: isCurrUserFromAssetLogistics,
      isUserFromOps
    });
  };
    closeForm = async (e) => {
    const {OutageScheduleReportStore} = this.props
    this.setState({
      isFormVisible: false,
      formRowData: null,
      isAddMode: true,
      rowSelected: null,
      isDirectRoute: false,
      isAcknowledgerRole: false,
      isViewMode: false,
      OPIAndOPIMPEnabled: false,
      SCIAndSCIMPEnabled: false,
      selectedRegnFrm: null,
      isUserFromOps: false,
      editRowData: '',
      isRowDoubleClicked: false
    });
    OutageScheduleReportStore.clearDataOnRegnChange()
    };
    editRow = async (e) => {
    const currentScreen = this.getCurrentScreen()
    const { editRowData } = this.state
    const { OutageScheduleReportStore, CommonStore } = this.props
    const districtFilter = [{name: 'DIVISION', value: editRowData['Division']}]
    const lineSegmentFilter = [{name: 'ConsoleId', value: editRowData['ConsoleId']}]
    const consoleFilter = [{name: 'Active', value: 1}]

    if(editRowData.Region === 'Plains - South'){
      consoleFilter.push({name: 'ControlCenter', value: 'Midland'})
        await OutageScheduleReportStore.getPaaDistrictData(currentScreen, CommonStore, districtFilter)
        await OutageScheduleReportStore.getPaaAssetData(currentScreen, CommonStore, [])
        await OutageScheduleReportStore.getSegmentData(currentScreen, CommonStore, [])
    }
    if(editRowData.Region === 'Plains - North'){
      consoleFilter.push({name: 'ControlCenter', value: 'Olds'})
        await OutageScheduleReportStore.getPmcDistrictData(currentScreen, CommonStore, districtFilter)
        await OutageScheduleReportStore.getSegmentData(currentScreen, CommonStore, lineSegmentFilter)
    }
    if(editRowData.Region === 'Plains - South' || editRowData?.PinId){
      await OutageScheduleReportStore.getReasonShutdownData(currentScreen, CommonStore)
    }
    if(editRowData.Region === 'Plains - North' && !editRowData?.PinId){
      await OutageScheduleReportStore.getWorkTypeData(currentScreen, CommonStore)
    }
    await OutageScheduleReportStore.getConsoleData(currentScreen, CommonStore, consoleFilter)
    await OutageScheduleReportStore.getVolumetricEventType(currentScreen, CommonStore)

    //Here???


    this.setState({ filterModel: this.state.gridOptions.api.getFilterModel(), sortModel: this.state.gridOptions.api.getSortModel() });
    this.setState({ isFormVisible: true, formRowData: null, isAddMode: false, selectedRegnFrm: editRowData?.Region });

  };
  viewScreen = async (row) => {
    const currentScreen = this.getCurrentScreen()
    const { OutageScheduleReportStore, CommonStore } = this.props
    let selectedRow = this.state.gridOptions.api.getSelectedRows();
    const editRowData = selectedRow?.[0] || {}
    const lineSegmentFilter = [{name: 'ConsoleId', value: editRowData['ConsoleId']}]
    const districtFilter = [{name: 'DIVISION', value: editRowData['Division']}]
    const assetFilter = [
      {name: 'DIVISION', value: editRowData['Division']},
      {name: 'DISTRICT', value: editRowData['District']}
    ]
    const consoleFilter = [{name: 'Active', value: 1}]

    if(editRowData?.Region === 'Plains - South'){
      consoleFilter.push({name: 'ControlCenter', value: 'Midland'})
      await OutageScheduleReportStore.getPaaDivisionData(currentScreen, CommonStore)
      await OutageScheduleReportStore.getPaaDistrictData(currentScreen, CommonStore, districtFilter)
      await OutageScheduleReportStore.getPaaAssetData(currentScreen, CommonStore, [])
    }
    if(editRowData?.Region === 'Plains - North'){
      consoleFilter.push({name: 'ControlCenter', value: 'Olds'})
      await OutageScheduleReportStore.getPmcDistrictData(currentScreen, CommonStore, districtFilter)
      await OutageScheduleReportStore.getPmcAssetData(currentScreen, CommonStore, assetFilter)
    }
    if(editRowData?.PinId || editRowData.Region === 'Plains - South'){
      await OutageScheduleReportStore.getReasonShutdownData(currentScreen, CommonStore)
    }else if(editRowData.Region === 'Plains - North' && !editRowData?.PinId){
      await OutageScheduleReportStore.getWorkTypeData(currentScreen, CommonStore)
    }

    await OutageScheduleReportStore.getConsoleData(currentScreen, CommonStore, consoleFilter)
    await OutageScheduleReportStore.getSegmentData(currentScreen, CommonStore, lineSegmentFilter)
    await OutageScheduleReportStore.getVolumetricEventType(currentScreen, CommonStore)

    this.setState({ rowSelected: selectedRow.length, editRowData: selectedRow[0], previousAcknowledgement: selectedRow[0]?.IsAcknowledged, filterModel: this.state.gridOptions.api.getFilterModel(), sortModel: this.state.gridOptions.api.getSortModel() });
    this.setState({ isViewMode: true });
    this.setState({ isFormVisible: true, formRowData: null, isAddMode: false, selectedRegnFrm: selectedRow[0]?.Region });
  }
  onRowDoubleClicked = () => {
    this.setState({isRowDoubleClicked: true})
    this.viewScreen()
  }
    onSelectionChanged = async (e) => {
    const selectedRow = this.state.gridOptions.api.getSelectedRows();
    this.setState({ rowSelected: selectedRow.length, editRowData: selectedRow[0], previousAcknowledgement: selectedRow[0]?.IsAcknowledged });
    const editRowObj = selectedRow[0];
    if (editRowObj) {
      this.setFormAccess(editRowObj["CreatedRole"], editRowObj["FacilityId"], editRowObj["DistrictId"], editRowObj["Region"]);

    }
  };
  handleRegionInForm = async (event) => {
    event.persist()
    const currentScreen = this.getCurrentScreen()
    const {OutageScheduleReportStore, CommonStore} = this.props
    const {editRowData} = this.state
    const selectedRegion = event?.target?.value

    const divisonFilter = [
      {name: 'Active', value: 1}
    ]
    const consoleFilter = [{name: 'Active', value: 1}]

    this.setState({selectedRegnFrm: selectedRegion})

    OutageScheduleReportStore.clearDataOnRegnChange()
    
    if(selectedRegion === 'Plains - South'){
      consoleFilter.push({name: 'ControlCenter', value: 'Midland'})
        await OutageScheduleReportStore.getPaaDivisionData(currentScreen, CommonStore, divisonFilter)
        //await OutageScheduleReportStore.getPaaAssetData(currentScreen, CommonStore, [])
    }
  
    if(selectedRegion === 'Plains - South' || editRowData?.PinId){
      await OutageScheduleReportStore.getReasonShutdownData(currentScreen, CommonStore)
    }else if(selectedRegion === 'Plains - North'){
      consoleFilter.push({name: 'ControlCenter', value: 'Olds'})
      await OutageScheduleReportStore.getWorkTypeData(currentScreen, CommonStore)
    }
    
    await OutageScheduleReportStore.getConsoleData(currentScreen, CommonStore, consoleFilter)
    await OutageScheduleReportStore.getVolumetricEventType(currentScreen, CommonStore)
    await OutageScheduleReportStore.getSegmentData(currentScreen, CommonStore, [])
  }

  handleDivsionInForm = async (event, selectedRegion) => {
    event.persist()
    const {isAddMode} = this.state
    const currentScreen = this.getCurrentScreen()
    const { OutageScheduleReportStore, CommonStore } = this.props

    let selectedDiv = null
    const districtFilter = [
      {name: 'DIVISION', value: null},
      {name: 'Active', value: 1}
    ]

    if(selectedRegion === 'Plains - North'){
      selectedDiv = OutageScheduleReportStore.pmcDivisionData.find(item => item.value === event?.target?.value)
      districtFilter[0].value = selectedDiv?.label
      districtFilter[1].name = 'IsActive'
      await OutageScheduleReportStore.getPmcDistrictData(currentScreen, CommonStore, districtFilter)
    }
    if(selectedRegion === 'Plains - South'){
      selectedDiv = OutageScheduleReportStore.paaDivisionData.find(item => {
        const matchCriteria = isAddMode ? item.ID === Number(event?.target?.value) : item.TITLE === event?.target?.value
        return matchCriteria
      })
      districtFilter[0].value = selectedDiv?.TITLE
      await OutageScheduleReportStore.getPaaDistrictData(currentScreen, CommonStore, districtFilter)
    }
  }

  handleDivisionClickInForm = async (values) => {
    const currentScreen = this.getCurrentScreen()
    const {OutageScheduleReportStore, CommonStore} = this.props
    const {editRowData, isViewMode} = this.state
    const region = values?.Region
    const divisonFilter = [
      {name: 'Active', value: 1}
    ]

    if(editRowData){
      OutageScheduleReportStore.clearDataOnDivisionClick()
      if(region === 'Plains - South'){
        await OutageScheduleReportStore.getPaaDivisionData(currentScreen, CommonStore, divisonFilter)
      }
    }
  }

  handlAssetClickInForm = async (values, disabled) => {
    const currentScreen = this.getCurrentScreen()
    const { OutageScheduleReportStore, CommonStore } = this.props
    const {pmcAssetData, paaAssetData} = OutageScheduleReportStore
    const {editRowData, isViewMode} = this.state
    let selectedDivision = values?.Division || null
    const selectedRegion = values?.Region || null
    let assetFilter = [
      {name: 'DIVISION', value: selectedDivision},
      {name: 'DISTRICT', value: editRowData['District']},
      {name: 'Status', value: 'ACTIVE'}
    ]
  
    if(disabled !== true){
      if(selectedRegion === 'Plains - North' && pmcAssetData?.length === 0){
        assetFilter[2] = {name: 'IsActive', value: 1}
        await OutageScheduleReportStore.getPmcAssetData(currentScreen, CommonStore, assetFilter)
      }
      if(selectedRegion === 'Plains - South' && paaAssetData?.length === 0){
        await OutageScheduleReportStore.getPaaAssetData(currentScreen, CommonStore, [])
      }
    }
  }

  handleDistrictInForm = async (option, values) => {
    const currentScreen = this.getCurrentScreen()
    const { OutageScheduleReportStore, CommonStore } = this.props
    const {editRowData} = this.state
    let selectedDivision = values?.Division || null
    const selectedRegion = values?.Region || null
    let assetFilter = [
      {name: 'DIVISION', value: selectedDivision},
      {name: 'DISTRICT', value: null},
      {name: 'Status', value: 'ACTIVE'}
    ]

    if(selectedRegion === 'Plains - North'){
      assetFilter[1].value = option?.label
      assetFilter[2] = {name: 'IsActive', value: true}
      await OutageScheduleReportStore.getPmcAssetData(currentScreen, CommonStore, assetFilter)
    }
    if(selectedRegion === 'Plains - South' && option?.length){
      if(!editRowData){        
        selectedDivision = OutageScheduleReportStore.paaDivisionData.find(item => item.ID === Number(selectedDivision)) || null
        assetFilter[0].value = selectedDivision?.TITLE
      }
      assetFilter[1].value = option.reduce((acc, currVal) => {
        acc = acc === null ? currVal?.label : `${acc}, ${currVal.label}`
        return acc
        }, null)
      //await OutageScheduleReportStore.getPaaAssetData(currentScreen, CommonStore, assetFilter)
    }
  }

  handleConsoleInForm = async (event) => {
    const {isAddMode} = this.state
    event.persist()
    const { OutageScheduleReportStore, CommonStore } = this.props
    const currentScreen = this.getCurrentScreen()
    let selectedConsole = null 
    if(isAddMode){
      selectedConsole = event?.target?.value
    }else{
      selectedConsole = OutageScheduleReportStore.consoleData.find(item => item.Title === event?.target?.value)?.ID || null
    }

    const lineSegmentFilter = [{name: 'ConsoleId', value: selectedConsole}]
    await OutageScheduleReportStore.getSegmentData(currentScreen, CommonStore, lineSegmentFilter)
  }

  getDistinctValues = (data, uniqByFlag, uniqField) => {
    let distinctValues = []
    if(data?.length){
      distinctValues = Array.from(new Set(data.map(item => item[uniqByFlag])))
        .map(val => {
          let value = null
          let label = null
          const valueOrlabel = data.find(item => item[uniqByFlag] === val)[uniqField]
          if(['ID', 'Id'].includes(uniqByFlag)){
            value = val
            label = valueOrlabel
          }
          if(['DISTRICT', 'DIVISION'].includes(uniqByFlag)){
            label = val
            value = valueOrlabel
          }
          return {
            value,
            label
          }
        })
    }

    return distinctValues
  }

  getPrimaryContactForSouthRgn = (option) => {
    const { paaDistrictData } = this.props.OutageScheduleReportStore
    if(option?.length){
    const southDistManagers = option.reduce((acc, currVal) => {
      if(currVal?.label){
        const dist = paaDistrictData.find(item => item.Title === currVal?.label)
        if(dist?.District_Manager)
        acc.push(dist.District_Manager)
      }
      return acc
      }, [])

      return southDistManagers.join(', ').toString()
    }
    return ''
  }

  timeZoneLabel = (selectedRegion) => {
    if(selectedRegion && selectedRegion === 'Plains - South'){
      return <span className="time-zone-container">CST</span>
    }
    if(selectedRegion && selectedRegion === 'Plains - North'){
      return<span className="time-zone-container">MST</span>
    }

    return null
  }

  renderForm() {
    const {
      isAddMode, isSameGroupUserRole, editRowData, isReadOnlyRoleUser,
      isViewMode, isAcknowledgerRole, primaryContactSuggestions, 
      secondaryContactSuggestions, lastAckBy, OPIAndOPIMPEnabled, SCIAndSCIMPEnabled, 
      regions, selectedRegnFrm, isUserFromOps
      } = this.state;
    const { OutageScheduleReportStore } = this.props;
    const currentScreen = this.getCurrentScreen()
    const { screen, screenColumns: columns } = currentScreen;
    const { pmcAssetData, paaAssetData, consoleData, segmentData, workTypeData, 
      reasonShutdownData, pmcDistrictData, paaDistrictData, pmcDivisionData, 
      paaDivisionData, eventTypeData
    } = outageScheduleReportStore;
   let regionDropDownOptions = []
   let facilityDropdownOptions = []
   let divisionDropDownOptions = []
   let districtDropDownOptions = []
   let typeWorkDropdownOptions = []
   let consoleDropdownOptions = []
   let lineSegmentDropdownOptions = []
   let eventTypeDropdownOptions = []

   if(selectedRegnFrm === 'Plains - North'){
    divisionDropDownOptions = [...pmcDivisionData]

    if(pmcDistrictData?.length){
      districtDropDownOptions = this.getDistinctValues(pmcDistrictData, 'Id', 'Title')
    }
    if(pmcAssetData.length){
      facilityDropdownOptions = this.getDistinctValues(pmcAssetData, 'ID', 'ASSET')
    }
    if(workTypeData?.length){
        typeWorkDropdownOptions = this.getDistinctValues(workTypeData, 'ID', 'NAME')
    }
   }

   if(selectedRegnFrm === 'Plains - South'){
    if(paaDivisionData?.length){
      divisionDropDownOptions = this.getDistinctValues(paaDivisionData, 'ID', 'TITLE')
    }
    if(paaDistrictData?.length){
      districtDropDownOptions = this.getDistinctValues(paaDistrictData, 'Id', 'Title')
    }
    if(paaAssetData.length){
      facilityDropdownOptions = this.getDistinctValues(paaAssetData, 'ID', 'TITLE')
    }

    if(consoleData.length){
      consoleDropdownOptions = this.getDistinctValues(consoleData, 'ID', 'Title')
    }
  }
  if(segmentData?.length){
      lineSegmentDropdownOptions = this.getDistinctValues(segmentData, 'ID', 'Description')
  }

  if(reasonShutdownData?.length || editRowData?.PinId){
    typeWorkDropdownOptions = this.getDistinctValues(reasonShutdownData, 'ID', 'MAIN')
    typeWorkDropdownOptions = reasonShutdownData.reduce((acc, curr) => {
        const matchedItem = typeWorkDropdownOptions.find(item => {
          if(item.value === curr.ID){
            item.label = `${curr.TITLE} - ${item.label}`
            return item
          }
        })
        if(matchedItem?.label)
          acc.push(matchedItem)

        return acc
    }, [])
    typeWorkDropdownOptions = sortResources(typeWorkDropdownOptions)
  }

   if(eventTypeData?.length){
    eventTypeDropdownOptions = eventTypeData.map(item => {
      return {value: item.ID, label: item.Name}
    })
   }

    const currUserRegions = [...new Set([...OutageScheduleReportStore.loggedUserData
      .map(item => {
      if(item?.Region && item?.FacilityId > 0 && item?.IsActive === 1){
        return item.Region
      }})
    ])]

    if(currUserRegions.includes('S')){
      regionDropDownOptions.push(regions[0])
    }
    if(currUserRegions.includes('N')){
      regionDropDownOptions.push(regions[1])
    }
    if(editRowData && !regionDropDownOptions.map(item => item.label).includes(editRowData['Region'])){
      const editRegion = editRowData?.Region
      regionDropDownOptions.push({label: editRegion, value: editRegion})
    }

    var facilityObj = OutageScheduleReportStore.loggedUserData.map(function (item) { return item.FacilityId; });
    const currUserDistricts = OutageScheduleReportStore.loggedUserData.map(item =>  item?.DistrictId).filter(item => item!==null)
    const currUserDivisions = OutageScheduleReportStore.loggedUserData.map(item => item?.Division).filter(item => item!==null)
    if (isAddMode) {
      districtDropDownOptions = districtDropDownOptions.filter(item => currUserDistricts.includes(parseInt(item.value)))
        divisionDropDownOptions = divisionDropDownOptions.filter(item => currUserDivisions.includes(item.label))
        if (selectedRegnFrm === 'Plains - North') {
            facilityDropdownOptions = facilityDropdownOptions.filter(item => facilityObj.includes(parseInt(item.value)));
        }
    } else {
      if (editRowData) {
        if(!isViewMode){
          districtDropDownOptions = districtDropDownOptions.filter(item => {
            return currUserDistricts.includes(parseInt(item.value)) || (editRowData?.DistrictId?.split(';').includes(`${item.value}`))
          })
          divisionDropDownOptions = divisionDropDownOptions.filter(item => {
            return currUserDivisions.includes(item.label) || editRowData.Division === item.label
          })
            /* Show only those assets which logged-in user has access to */
        if (selectedRegnFrm === 'Plains - North') {
            const userAssets = []
            const currUserFacilityNames = OutageScheduleReportStore.loggedUserData.map(function (item) { return item.FacilityNm; });
            facilityDropdownOptions.forEach(item => {
                if (facilityObj.includes(item.value) ||
                    currUserFacilityNames.includes(item.label) ||
                    editRowData?.FacilityId?.split(';').includes(`${item.value}`) ||
                    editRowData?.Facility?.split('; ').includes(item.label)
                ) {
                    userAssets.push({ value: item.label, label: item.label })
                }
            })
            facilityDropdownOptions = userAssets
        }
        }
        if(isViewMode){
          facilityDropdownOptions = facilityDropdownOptions.map(item => {return {value: item.label, label: item.label}})
        }
        divisionDropDownOptions = divisionDropDownOptions.map(item => {
          return {value: item.label, label: item.label}
        })

        districtDropDownOptions = districtDropDownOptions.map(item => {
          return {value: item.label, label: item.label}
        })

        typeWorkDropdownOptions = typeWorkDropdownOptions.map(item => {
          return {value: item.label, label: item.label}
        })

        consoleDropdownOptions = consoleDropdownOptions.map(item => {
          return {value: item.label, label: item.label}
        })

        lineSegmentDropdownOptions = lineSegmentDropdownOptions.map(item => {
            return { value: item.label, label: item.label }
        })
          if (selectedRegnFrm === 'Plains - South') {
              facilityDropdownOptions = facilityDropdownOptions.map(item => {
                  return { value: item.label, label: item.label }
              })
          }
      }
    }

    if(editRowData?.Region === 'Plains - North' && divisionDropDownOptions.length === 0){
      divisionDropDownOptions = [{label: editRowData['Division'], value: editRowData['Division']}]
    }
    if(editRowData?.Region === 'Plains - South' && !paaDivisionData?.length){
      divisionDropDownOptions = [{label: editRowData['Division'], value: editRowData['Division']}]
    }
    if(editRowData?.Region === 'Plains - North' && !pmcAssetData?.length){
      facilityDropdownOptions = [{label: editRowData['Facility'], value: editRowData['Facility']}]
    }
    if(editRowData?.Region === 'Plains - South' && !paaAssetData?.length){
      let facilities = editRowData?.Facility?.split('; ') || []
      facilities.forEach(fac => {
        facilityDropdownOptions.push({label: fac, value: fac})
      })
    }

    /** if console and line segment from the to be edited outage doesn't exist in dropdown 
     * options and region in to be edited outage and region in the form are same then
     * manually display console and line segment
    */
    if(editRowData && !consoleDropdownOptions.map(item => item.label).includes(editRowData['Console']) && editRowData['Region'] === selectedRegnFrm){
      consoleDropdownOptions.push({label: editRowData['Console'], value: editRowData['Console']})
    }
    
    if(editRowData?.PipeSegment && lineSegmentDropdownOptions.length === 0){
      const segments = editRowData?.PipeSegment?.split('; ') || []
      if(segments?.length)
        segments.forEach(seg => { lineSegmentDropdownOptions.push({label: seg, value: seg})})
    }

    facilityDropdownOptions = sortBy(facilityDropdownOptions,
      [function (item) { return toUpper(item.label) }])

    var statusDropdownOptions = columns?.find((x) => x.name === "Status")
      .refLookupData?.lookupValues.values;
    const schedulingImpactOptions = columns?.find((x) => x.name === "SchedulingImpact")
      .refLookupData?.lookupValues.values;

    divisionDropDownOptions = uniqBy(divisionDropDownOptions, 'label')
    districtDropDownOptions = uniqBy(districtDropDownOptions, 'label')
    facilityDropdownOptions = uniqBy(facilityDropdownOptions, 'label')
    consoleDropdownOptions = uniqBy(consoleDropdownOptions, 'label')
    lineSegmentDropdownOptions = uniqBy(lineSegmentDropdownOptions, 'label')
    typeWorkDropdownOptions = uniqBy(typeWorkDropdownOptions, 'label')

    var dateConfirmationDropdownOptions = columns?.find(
      (x) => x.name === "DateConfirmation"
    )?.refLookupData?.lookupValues.values;
    const validationSchema = Yup.object().shape({
      Status: Yup.string().required("Status is required"),
      Title: Yup.string().required("Title is required"),
      Region: Yup.string().required("Region is required"),
      Division: Yup.string().required("Division is required"),
      District: Yup.string().required("District is required"),
      Facility: Yup.string().required("Asset/Location is required"),
      TypeOfWork: Yup.string().required("Type Of Work/Reason for Shutdown is required"),
      Console: selectedRegnFrm === 'Plains - North' ? Yup.string().nullable().optional() :
        Yup.string().required("Console is required"),
      PipeSegment: selectedRegnFrm === 'Plains - North' ? Yup.string().nullable().optional() :
        Yup.string().required("Pipe Segment is required"),
      PrimaryContact: editRowData?.PinId ? Yup.string().nullable().optional() : Yup.string().required("Primary Contact is required"),
      DescriptionOfMaintenance: Yup.string().required(
        "Description of Maintenance is required"
      ),
      Duration: editRowData?.PinId ? Yup.string().required("Duration in range is required") : 
        Yup.number().integer("You must specify a number").required("Duration is required").positive().typeError("You must specify a number"),
      StartDate: Yup.string().required("Start Date is required"),
        DateConfirmation: currentScreen.screen.name !== "OutageSchedule" ? Yup.string().nullable().optional() :
        Yup.string().required("Date Confirmation is required"),
      SchedulingImpact: SCIAndSCIMPEnabled && selectedRegnFrm !== 'Plains - South' ?
        Yup.string().nullable().required("Scheduling Impact is required") : Yup.string().nullable(),
      SchedulingImpactAndMitigationPlan: Yup.string().ensure().when(['SchedulingImpact'], {
        is: (SchedulingImpact) => {
          const matchingSchedulingImpact = schedulingImpactOptions.find(
            item => item.value === SchedulingImpact
          )
          return SchedulingImpact && matchingSchedulingImpact?.label !== 'None'
        },
        then: Yup.string().required(`Scheduling Impact & Mitigation 
        Plan must be entered if Scheduling Impact selected is low, medium, or high.`)
      }),
      EventTypeId: isUserFromOps && selectedRegnFrm !== 'Plains - North' ? 
        Yup.string().required("Event Type is required") : Yup.string().optional(),
    }, ['SchedulingImpactAndMitigationPlan'])
    return (
      <Formik
        initialValues={OutageScheduleReportStore.initialValues}
        validationSchema={validationSchema}
        onSubmit={(fields) => { this.saveScreenData(fields); }}
      >
        {({ errors, touched, isSubmitting, setFieldValue, values, setTouched }) => {
          const [outage, setUser] = useState({});
          let title = "";
          useEffect(() => {
            if (!isAddMode) {
              const selectedRow = editRowData;
              const fields = outageScheduleReportStore.fields;
              fields.forEach((field) =>
                setFieldValue(field, selectedRow[field], false)
              );
              let stDate = selectedRow["StartDate"] ? moment(selectedRow["StartDate"]).toDate() : null;
              let endDate = selectedRow["EndDate"] ? moment(selectedRow["EndDate"]).toDate() : null;
              let ccRestarteDate = selectedRow["CCRestartDate"] ? moment(selectedRow["CCRestartDate"]).toDate() : null
              const otgConsole = selectedRow['Console'] ? selectedRow['Console'] : ''
              const lineSegment = selectedRow['PipeSegment'] ? selectedRow['PipeSegment'] : ''
              const eventTypeId = selectedRow['EventTypeId'] ? selectedRow['EventTypeId'] : ''  
              stDate = stDate ? getRegionBasedDateTime(selectedRow.StartDate, selectedRow.Region) : null
              endDate = endDate ? getRegionBasedDateTime(selectedRow.EndDate, selectedRow.Region) : null
              ccRestarteDate = ccRestarteDate ? getRegionBasedDateTime(selectedRow.CCRestartDate, selectedRow.Region) : null
              setFieldValue("StartDate", stDate, false);
              setFieldValue("EndDate", endDate, false);
              setFieldValue("CCRestartDate", ccRestarteDate, false)
              setFieldValue("Console", otgConsole, false);
              setFieldValue("PipeSegment", lineSegment, false);
              setFieldValue("EventTypeId", eventTypeId, false);
              const jsonStringOBJ = sessionStorage.getItem('AUTH_TOKEN'); // This is the json string we stored
              const nameObj = JSON.parse(jsonStringOBJ);
              if (nameObj && nameObj.displayName && !isSameGroupUserRole && isAcknowledgerRole) {
                setFieldValue("AcknowledgedBy", nameObj.displayName, false);
              }
              if (selectedRow["IsAcknowledged"] != null || selectedRow["CtrOpsAcknowledged"] != null || selectedRow["CtrLogisticssAcknowledged"] != null) {
                let lastAckBy = selectedRow["AcknowledgedBy"] ? selectedRow["AcknowledgedBy"] : null;
                this.setState({ lastAckBy: lastAckBy });
              }
              else {
                this.setState({ lastAckBy: null });
              }
              title = selectedRow["Title"];
              setUser(outage);
            }
          }, []);
          return (
            <Form>
              <h1>{isAddMode ? "New Item" : "Title: " + values.Title}{!isAddMode && (<span className="otg-otgid">{" (Outage ID: " + values.ID + ")"}</span>)}</h1>
              <div className="row">
                {
                  (screen.name != "OutageSchedule") ? (
                    <div className="col-md-4">
                      <div className="form-group">
                        <div className="row">
                          <div className=" col-md-3">
                            <label className="otg-formlabel">PIN ID<span className="otg-reqicon"><FontAwesomeIcon icon={faAsterisk} /></span></label>
                          </div>
                          <div className=" col-md-9">
                            <Field
                              name="PinId" type="text" disabled={true}
                              className={"form-control" + (errors.PinId && touched.PinId ? " is-invalid" : "")}
                            />
                            <ErrorMessage name="PinId" component="div" className="invalid-feedback" />
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : ''
                }
                <div className="col-md-4">
                  <div className="form-group">
                    <div className="row">
                      <div className=" col-md-3">
                        <label className="otg-formlabel">Status<span className="otg-reqicon"><FontAwesomeIcon icon={faAsterisk} /></span></label>
                      </div>
                      <div className=" col-md-9">
                        <Field
                          name="Status" as="select" disabled={!isSameGroupUserRole || isViewMode || values?.PinId}
                          className={"form-control" + (errors.Status && touched.Status ? " is-invalid" : "")}
                        >
                          <option key="" value="">Select Status</option>
                          {statusDropdownOptions.map((option) => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </Field>
                        <ErrorMessage name="Status" component="div" className="invalid-feedback" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <div className="row">
                      <div className=" col-md-3">
                        <label className="otg-formlabel">Title<span className="otg-reqicon"><FontAwesomeIcon icon={faAsterisk} /></span></label>
                      </div>
                      <div className=" col-md-9">
                        <Field
                          name="Title" type="text" disabled={!isSameGroupUserRole || isViewMode || values?.PinId}
                          className={"form-control" + (errors.Title && touched.Title ? " is-invalid" : "")}
                        />
                        <ErrorMessage name="Title" component="div" className="invalid-feedback" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                    <div className="row">
                      <div className=" col-md-3">
                        <label className="otg-formlabel">Region<span className="otg-reqicon"><FontAwesomeIcon icon={faAsterisk} /></span></label>
                      </div>
                      <div className=" col-md-9">
                        <Field
                          name="Region" as="select" disabled={!isSameGroupUserRole || isViewMode || values?.PinId} 
                          onChange={event => {
                            this.handleRegionInForm(event)
                            setFieldValue('Region', event?.target?.value)
                            setFieldValue('Division', '')
                            // setFieldValue('District', '')
                            // setFieldValue('Facility', '')
                            setFieldValue('District', values?.Region === 'Plains - North' ? '' : [])
                            setFieldValue('Facility', values?.Region === 'Plains - North' ? '' : [])
                            setFieldValue('Console', '')
                            setFieldValue('PipeSegment', '')
                            setFieldValue('TypeOfWork', '')
                            setFieldValue('PrimaryContact', '')
                            setFieldValue('CCRestartDate', '')
                            setTouched({}, false)
                          }}
                          className={"form-control" + (errors.Region && touched.Region ? " is-invalid" : "")}
                        >
                          <option key="" value="">Select Region</option>
                          {regionDropDownOptions.map((option) => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </Field>
                        <ErrorMessage name="Region" component="div" className="invalid-feedback" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <div className="row">
                      <div className=" col-md-3">
                        <label className="otg-formlabel">Division<span className="otg-reqicon"><FontAwesomeIcon icon={faAsterisk} /></span></label>
                      </div>
                      <div className=" col-md-9">
                        <Field
                          name="Division" as="select" disabled={!isSameGroupUserRole || isViewMode || values?.PinId}
                          onChange={event => {
                            this.handleDivsionInForm(event, values?.Region)
                            setFieldValue('Division', event?.target?.value)
                            setFieldValue('District', values?.Region === 'Plains - North' ? '' : [])
                            setFieldValue('Facility', values?.Region === 'Plains - North' ? '' : [])
                            setFieldValue('PrimaryContact', '')
                          }}
                          onClick={event => {
                            let check = false 
                            if(values?.Region === 'Plains - North'){
                              check = pmcDivisionData.length === 0
                            }
                            if(values?.Region === 'Plains - South'){
                              check = paaDivisionData?.length === 0
                            }
                            if(editRowData && check){
                              this.handleDivisionClickInForm(values)
                            }
                          }}
                          className={"form-control" + (errors.Division && touched.Division ? " is-invalid" : "")}
                        >
                          <option key="" value="">Select Division</option>
                          {divisionDropDownOptions.map((option) => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </Field>
                        <ErrorMessage name="Division" component="div" className="invalid-feedback" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <div className="row">
                      <div className=" col-md-3">
                        <label className="otg-formlabel">District<span className="otg-reqicon"><FontAwesomeIcon icon={faAsterisk} /></span></label>
                      </div>
                      <div className=" col-md-9">
                        <Field name="District">
                        {props => {
                          const customDistProps = {
                            ...props,
                            handleDistrictInForm: this.handleDistrictInForm,
                            getPrimaryContactForSouthRgn: this.getPrimaryContactForSouthRgn,
                            options: districtDropDownOptions,
                            placeholder: "Select District",
                            makeActiveDistList: this.props.OutageScheduleReportStore.makeActiveDistList,
                            isAddMode,
                            isViewMode,
                            pmcDistrictData,
                            paaDistrictData,
                            disabled: !isSameGroupUserRole || isViewMode || values?.PinId,
                            isMulti: values?.Region === 'Plains - South'
                          }
                          return (
                            <>
                              <CustomSelect {...customDistProps}/>
                              <CustomSelectErrorMessage {...props}/>
                            </>
                          )
                        }}
                        </Field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                    <div className="row">
                      <div className=" col-md-3">
                        <label className="otg-formlabel">Asset/Location<span className="otg-reqicon"><FontAwesomeIcon icon={faAsterisk} /></span></label>
                      </div>
                      <div className=" col-md-9">
                        <Field name="Facility">
                          {props => {
                            const customFacilityProps = {
                              ...props,
                              onClickHandler: this.handlAssetClickInForm,
                              options: facilityDropdownOptions,
                              disabled: !isSameGroupUserRole || isViewMode || values?.PinId,
                              isMulti: values?.Region === 'Plains - South',
                              placeholder: "Select Asset/Location"
                            }
                            return (
                              <>
                                <CustomSelect {...customFacilityProps}/>
                                <CustomSelectErrorMessage {...props}/>
                              </>
                            )
                          }}
                        </Field>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <div className="row">
                      <div className=" col-md-3">
                        <label className="otg-formlabel">Station/Terminal/ LACT Affected</label>
                      </div>
                      <div className=" col-md-9">
                        <Field
                          name="Section" type="text" disabled={!isSameGroupUserRole || isViewMode || values?.Region === 'Plains - South'}
                          className={"form-control" + (errors.Section && touched.Section ? " is-invalid" : "")}
                        />
                        <ErrorMessage name="Section" component="div" className="invalid-feedback" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                    <div className="row">
                      <div className=" col-md-3">
                        <label className="otg-formlabel">Type of Work/Reason for Shutdown
                          <span className="otg-reqicon"><FontAwesomeIcon icon={faAsterisk} /></span></label>
                      </div>
                      <div className=" col-md-9">
                        <Field name="TypeOfWork" as="select" disabled={!isSameGroupUserRole || isViewMode || values?.PinId}
                          className={"form-control" + (errors.TypeOfWork && touched.TypeOfWork ? " is-invalid" : "")} >
                          <option key="" value=""> Select Type Of Work / Reason for Shutdown</option>
                          {typeWorkDropdownOptions.map((option) => (
                              <option key={option.value} value={option.value}> {option.label} </option>
                          ))}
                        </Field>
                        <ErrorMessage name="TypeOfWork" component="div" className="invalid-feedback" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <div className="row">
                      <div className=" col-md-3">
                        <label className="otg-formlabel">Console<span className="otg-reqicon"><FontAwesomeIcon icon={faAsterisk} /></span></label>
                      </div>
                      <div className=" col-md-9">
                        <Field
                          name="Console" as="select" disabled={!isSameGroupUserRole || isViewMode || values?.Region === 'Plains - North' || values?.PinId}
                          className={"form-control" + (errors.Console && touched.Console ? " is-invalid" : "")}
                          onChange={(event) => {
                           //this.handleConsoleInForm(event)
                            setFieldValue('Console', event?.target?.value)
                          }}
                        >
                          <option key="" value=""> Select Console </option>
                          {consoleDropdownOptions.map((option) => (
                              <option key={option.value} value={option.value}> {option.label} </option>
                          ))}
                        </Field>
                        <ErrorMessage name="Console" component="div" className="invalid-feedback" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                <div className="form-group">
                  <div className="row">
                    <div className=" col-md-3">
                      <label className="otg-formlabel">Pipe Segment<span className="otg-reqicon"><FontAwesomeIcon icon={faAsterisk} /></span></label>
                    </div>
                    <div className=" col-md-9">
                      <Field name="PipeSegment">
                        {props => {
                          const customPipeSegmentProps = {
                            ...props,
                            options: lineSegmentDropdownOptions,
                            disabled: !isSameGroupUserRole || isViewMode || values?.Region === 'Plains - North' || values?.PinId,
                            isMulti: values?.Region === 'Plains - South' || values?.Region === 'Plains - North',
                            // isMulti: true,
                            placeholder: "Select Pipe Segment"
                          }
                          return (
                            <>
                              <CustomSelect {...customPipeSegmentProps}/>
                              <CustomSelectErrorMessage {...props}/>
                            </>
                          )
                        }}
                      </Field>
                    </div>
                  </div>
                </div>
              </div>
              </div>
              {screen?.name === "OutageSchedule" ? (
                <>
                <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                    <div className="row">
                      <div className=" col-md-3">
                        <label className="otg-formlabel">Primary Contact
                          <span className="otg-reqicon"><FontAwesomeIcon icon={faAsterisk} /></span></label>
                      </div>
                      <div className=" col-md-9">
                        <Field name="PrimaryContact" type="text" disabled={!isSameGroupUserRole || isViewMode || values?.PinId || values?.Region === 'Plains - South'}
                          className={"form-control" + (errors.PrimaryContact && touched.PrimaryContact ? " is-invalid" : "")}
                          onChange={(val) => {
                            if(values?.Region === 'Plains - North'){
                            this.loadSugession(val, "Primary")
                              .then(setFieldValue("PrimaryContact", val.currentTarget.value));
                            }
                          }} />
                        <ul className="suggestions">
                          {
                            primaryContactSuggestions && primaryContactSuggestions.map((suggestion, index) => {
                              return (
                                <li key={suggestion} onClick={() => {
                                  setFieldValue("PrimaryContact", suggestion.displayName);
                                  this.setState({ primaryContactSuggestions: [] });
                                }}>{suggestion.displayName}</li>
                              );
                            })
                          }
                        </ul>
                        <ErrorMessage name="PrimaryContact" component="div" className="invalid-feedback" />
                      </div>
                    </div>
                  </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <div className="row">
                        <div className=" col-md-3">
                          <label className="otg-formlabel">Responsible Person</label>
                        </div>
                        <div className=" col-md-9">
                          <Field name="ResponsiblePerson" type="text" disabled={!isSameGroupUserRole || isViewMode || values?.Region === 'Plains - South'}
                            className={"form-control" + (errors.ResponsiblePerson && touched.ResponsiblePerson ? " is-invalid" : "")}
                            onChange={(val) => {
                              this.loadSugession(val, "Secondary")
                                .then(setFieldValue("ResponsiblePerson", val.currentTarget.value));
                            }} />
                          <ul className="suggestions">
                            {
                              secondaryContactSuggestions && secondaryContactSuggestions.map((suggestion, index) => {
                                return (
                                  <li key={suggestion} onClick={() => {
                                    setFieldValue("ResponsiblePerson", suggestion.displayName);
                                    this.setState({ secondaryContactSuggestions: [] });
                                  }}>{suggestion.displayName}</li>
                                );
                              })
                            }
                          </ul>
                          <ErrorMessage name="ResponsiblePerson" component="div" className="invalid-feedback" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                        <div className="row">
                          <div className=" col-md-3"><label className="otg-formlabel">Date Confirmation
                            <span className="otg-reqicon"><FontAwesomeIcon icon={faAsterisk} /></span></label></div>
                          <div className=" col-md-9">
                            <Field name="DateConfirmation" as="select" disabled={!isSameGroupUserRole || isViewMode || values?.PinId}
                              className={"form-control" + (errors.DateConfirmation && touched.DateConfirmation ? " is-invalid" : "")}>
                              <option key="" value=""> Select Date Confirmation </option>
                              {dateConfirmationDropdownOptions.map((option) => (
                                <option key={option.value} value={option.value}> {option.label} </option>
                              ))}
                            </Field>
                            <ErrorMessage name="DateConfirmation" component="div" className="invalid-feedback" />
                          </div>
                        </div>
                    </div>
                  </div>
                  <div className="col-md-4"></div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <div className="row">
                        <div className=" col-md-3">
                          <label className="otg-formlabel">Control Centre Restart Date/Time</label>
                        </div>
                        <div className=" col-md-9">
                          <span style={{display: 'flex'}}>
                          <DatePicker
                            popperClassName={"form-control" + (errors.CCRestartDate && touched.CCRestartDate ? " is-invalid" : "")}
                            selected={values?.CCRestartDate && moment(values.CCRestartDate).toDate() ? new Date(moment(values.CCRestartDate)) : null}
                            showTimeSelect
                            timeIntervals={15}
                            dateFormat={"MM/dd/yyyy hh:mm a"}
                            timeInputLabel="Time:"
                            showMonthDropdown 
                            showYearDropdown 
                            dropdownMode="select"
                            className="form-control otg-datepicker"
                            disabled={!isSameGroupUserRole || isViewMode || values?.PinId || ['Plains - North', null, ''].includes(values?.Region)}
                            onChange={(val) => { setFieldValue("CCRestartDate", moment(val)); }}
                            />
                            {this.timeZoneLabel(values.Region)}
                            </span>
                          <ErrorMessage name="CCRestartDate" component="div" className="invalid-feedback" />
                      </div>
                    </div>
                  </div>
                </div>
                </div>
                <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                      <div className="row">
                        <div className=" col-md-3"> <label className="otg-formlabel">Start Date
                          <span className="otg-reqicon"><FontAwesomeIcon icon={faAsterisk} /></span></label></div>
                        <div className=" col-md-9">
                          <span style={{display: 'flex'}}>
                          <DatePicker
                            popperClassName={"form-control" + (errors.StartDate && touched.StartDate ? " is-invalid" : "")}
                            selected={values.StartDate ? new Date(moment(values.StartDate)) : null}
                            showTimeSelect
                            timeIntervals={15}
                            dateFormat={"MM/dd/yyyy hh:mm a"}
                            onChange={(val) => {
                              setFieldValue("StartDate", moment(val));
                              if (values.Duration && Number(values.Duration) > 0) {
                                setFieldValue("EndDate", moment(val).add(values.Duration, 'hours'));
                              }
                            }}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control otg-datepicker"
                            timeInputLabel="Time:"
                            disabled={!isSameGroupUserRole || isViewMode || values?.PinId}
                            />
                            {this.timeZoneLabel(values.Region)}
                            </span>
                          <ErrorMessage name="StartDate" component="div" className="invalid-feedback" />
                          <div className="otgTextCmt"> Did you talk to OPS? Discuss with Operations to select an appropriate Start Date.</div>
                        </div>
                      </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <div className="row">
                      <div className=" col-md-3">
                        <label className="otg-formlabel">Estimated Duration of Outage
                          <span className="otg-reqicon"><FontAwesomeIcon icon={faAsterisk} /></span>
                        </label>
                      </div>
                      <div className=" col-md-9">
                        <Field name="Duration" type="text" disabled={!isSameGroupUserRole || isViewMode || values?.PinId}
                          className={"form-control" + (errors.Duration && touched.Duration ? " is-invalid" : "")}
                          onKeyUp={(val) => {
                            if (values.Duration !== null && values.Duration !== '') {
                              setFieldValue("EndDate", moment(values.StartDate).add(values.Duration, 'hours'));
                            } else {
                              setFieldValue("EndDate", null);
                            }
                          }}
                        />
                        <ErrorMessage name="Duration" component="div" className="invalid-feedback" />
                        <div className="otgTextCmt">Enter Duration in Hours.</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <div className="row">
                      <div className=" col-md-3">
                        <label className="otg-formlabel">System Restart/End Date/Time</label>
                      </div>
                      <div className=" col-md-9">
                        <span style={{display: 'flex'}}>
                          <DatePicker
                            className={"form-control otg-datepicker" + (errors.EndDate && touched.EndDate ? " is-invalid" : "")}
                            selected={values.EndDate ? moment(values.EndDate).toDate() : null}
                            dateFormat={"MM/dd/yyyy hh:mm a"}
                            onChange={(val) => { setFieldValue("EndDate", moment(val)); }}
                            showMonthDropdown showYearDropdown dropdownMode="select"
                            onChangeRaw={(e) => { e.preventDefault(); }} disabled={true}
                            />
                            {this.timeZoneLabel(values.Region)}
                          </span>
                        <ErrorMessage name="EndDate" component="div" className="invalid-feedback" />
                      </div>
                    </div>
                  </div>
                </div>
                </div>
              </>
              ) : (<>
              <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                    <div className="row">
                      <div className=" col-md-3">
                        <label className="otg-formlabel">Primary Contact
                          <span className="otg-reqicon"><FontAwesomeIcon icon={faAsterisk} /></span></label>
                      </div>
                      <div className=" col-md-9">
                        <Field name="PrimaryContact" type="text" disabled={!isSameGroupUserRole || isViewMode || values?.PinId || values?.Region === 'Plains - South'}
                          className={"form-control" + (errors.PrimaryContact && touched.PrimaryContact ? " is-invalid" : "")}
                          onChange={(val) => {
                            if(values?.Region === 'Plains - North'){
                            this.loadSugession(val, "Primary")
                              .then(setFieldValue("PrimaryContact", val.currentTarget.value));
                            }
                          }} />
                        <ul className="suggestions">
                          {
                            primaryContactSuggestions && primaryContactSuggestions.map((suggestion, index) => {
                              return (
                                <li key={suggestion} onClick={() => {
                                  setFieldValue("PrimaryContact", suggestion.displayName);
                                  this.setState({ primaryContactSuggestions: [] });
                                }}>{suggestion.displayName}</li>
                              );
                            })
                          }
                        </ul>
                        <ErrorMessage name="PrimaryContact" component="div" className="invalid-feedback" />
                      </div>
                    </div>
                  </div>
                  </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <div className="row">
                      <div className=" col-md-3">
                        <label className="otg-formlabel">Responsible Person</label>
                      </div>
                      <div className=" col-md-9">
                        <Field name="ResponsiblePerson" type="text" disabled={!isSameGroupUserRole || isViewMode || values?.Region === 'Plains - South'}
                          className={"form-control" + (errors.ResponsiblePerson && touched.ResponsiblePerson ? " is-invalid" : "")}
                          onChange={(val) => {
                            this.loadSugession(val, "Secondary")
                              .then(setFieldValue("ResponsiblePerson", val.currentTarget.value));
                          }} />
                        <ul className="suggestions">
                          {
                            secondaryContactSuggestions && secondaryContactSuggestions.map((suggestion, index) => {
                              return (
                                <li key={suggestion} onClick={() => {
                                  setFieldValue("ResponsiblePerson", suggestion.displayName);
                                  this.setState({ secondaryContactSuggestions: [] });
                                }}>{suggestion.displayName}</li>
                              );
                            })
                          }
                        </ul>
                        <ErrorMessage name="ResponsiblePerson" component="div" className="invalid-feedback" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <div className="row">
                      <div className=" col-md-3">
                        <label className="otg-formlabel">Control Centre Restart Date/Time</label>
                      </div>
                      <div className=" col-md-9">
                        <span style={{display: 'flex'}}>
                        <DatePicker
                          popperClassName={"form-control" + (errors.CCRestartDate && touched.CCRestartDate ? " is-invalid" : "")}
                          selected={values?.CCRestartDate && moment(values.CCRestartDate).toDate() ? new Date(moment(values.CCRestartDate)) : null}
                          showTimeSelect
                          timeIntervals={15}
                          dateFormat={"MM/dd/yyyy hh:mm a"}
                          timeInputLabel="Time:"
                          showMonthDropdown 
                          showYearDropdown 
                          dropdownMode="select"
                          className="form-control otg-datepicker"
                          disabled={!isSameGroupUserRole || isViewMode || values?.PinId || ['Plains - North', null, ''].includes(values?.Region)}
                          onChange={(val) => {
                            setFieldValue("CCRestartDate", val === null ? undefined : moment(val)); 
                          }}
                          />
                          {this.timeZoneLabel(values.Region)}
                          </span>
                        <ErrorMessage name="CCRestartDate" component="div" className="invalid-feedback" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                      <div className="row">
                        <div className=" col-md-3"> <label className="otg-formlabel">Start Date
                          <span className="otg-reqicon"><FontAwesomeIcon icon={faAsterisk} /></span></label></div>
                        <div className=" col-md-9">
                          <span style={{display: 'flex'}}>
                          <DatePicker
                            popperClassName={"form-control" + (errors.StartDate && touched.StartDate ? " is-invalid" : "")}
                            selected={values.StartDate ? new Date(moment(values.StartDate)) : null}
                            showTimeSelect
                            timeIntervals={15}
                            dateFormat={"MM/dd/yyyy hh:mm a"}
                            onChange={(val) => {
                              setFieldValue("StartDate", moment(val));
                              if (values.Duration && Number(values.Duration) > 0) {
                                setFieldValue("EndDate", moment(val).add(values.Duration, 'hours'));
                              }
                            }}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control otg-datepicker"
                            timeInputLabel="Time:"
                            disabled={!isSameGroupUserRole || isViewMode || values?.PinId}
                            />
                            {this.timeZoneLabel(values.Region)}
                            </span>
                          <ErrorMessage name="StartDate" component="div" className="invalid-feedback" />
                          <div className="otgTextCmt"> Did you talk to OPS? Discuss with Operations to select an appropriate Start Date.</div>
                        </div>
                      </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <div className="row">
                      <div className=" col-md-3">
                        <label className="otg-formlabel">Estimated Duration of Outage
                          <span className="otg-reqicon"><FontAwesomeIcon icon={faAsterisk} /></span>
                        </label>
                      </div>
                      <div className=" col-md-9">
                        <Field name="Duration" type="text" disabled={!isSameGroupUserRole || isViewMode || values?.PinId}
                          className={"form-control" + (errors.Duration && touched.Duration ? " is-invalid" : "")}
                          onKeyUp={(val) => {
                            if (values.Duration !== null && values.Duration !== '') {
                              setFieldValue("EndDate", moment(values.StartDate).add(values.Duration, 'hours'));
                            } else {
                              setFieldValue("EndDate", null);
                            }
                          }}
                        />
                        <ErrorMessage name="Duration" component="div" className="invalid-feedback" />
                        <div className="otgTextCmt">Enter Duration in Hours.</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <div className="row">
                      <div className=" col-md-3">
                        <label className="otg-formlabel">System Restart/End Date/Time</label>
                      </div>
                      <div className=" col-md-9">
                        <span style={{display: 'flex'}}>
                          <DatePicker
                            className={"form-control otg-datepicker" + (errors.EndDate && touched.EndDate ? " is-invalid" : "")}
                            selected={values.EndDate ? moment(values.EndDate).toDate() : null}
                            dateFormat={"MM/dd/yyyy hh:mm a"}
                            onChange={(val) => { setFieldValue("EndDate", moment(val)); }}
                            showMonthDropdown showYearDropdown dropdownMode="select"
                            onChangeRaw={(e) => { e.preventDefault(); }} disabled={true}
                            />
                            {this.timeZoneLabel(values.Region)}
                          </span>
                        <ErrorMessage name="EndDate" component="div" className="invalid-feedback" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              </>)}
              <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                    <div className="row">
                      <div className=" col-md-3">
                        <label className="otg-formlabel">
                          Cause of Outage<span className="otg-reqicon"><FontAwesomeIcon icon={faAsterisk} /></span>
                        </label>
                      </div>
                      <div className=" col-md-9">
                        <Field name="DescriptionOfMaintenance" type="textarea" component="textarea" rows="2"
                          disabled={!isSameGroupUserRole || isViewMode || values?.PinId}
                          className={
                            "form-control" + (errors.DescriptionOfMaintenance && touched.DescriptionOfMaintenance ? " is-invalid" : "")
                          } />
                        <ErrorMessage name="DescriptionOfMaintenance" component="div" className="invalid-feedback" />
                        <div className="otgTextCmt"> The description must be informative. Do not simply duplicate the title.</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                <div className="form-group">
                    <div className="row">
                      <div className=" col-md-3">
                        <label className="otg-formlabel">Controller Operational Actions Taken<span className="otg-reqicon"></span>
                        </label>
                      </div>
                      <div className=" col-md-9">
                        <Field name="ControllerOperationalAction" type="textarea" component="textarea" rows="2" 
                          disabled={true}
                          className={
                            "form-control" + (errors.ControllerOperationalAction && touched.ControllerOperationalAction ? " is-invalid" : "")
                          } />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className=" col-md-4">
                  <div className="form-group">
                    <div className="row">
                      <div className=" col-md-3">
                        <label className="otg-formlabel">Operations Impact</label>
                      </div>
                      <div className=" col-md-9">
                        <Field name="OperationsImpact" type="checkbox"  disabled={isViewMode || !OPIAndOPIMPEnabled || values?.Region === 'Plains - South'} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className=" col-md-4">
                  <div className="form-group">
                    <div className="row">
                      <div className=" col-md-3">
                        <label className="otg-formlabel">
                          Scheduling Impact
                          {SCIAndSCIMPEnabled ? <span className="otg-reqicon">
                            <FontAwesomeIcon icon={faAsterisk} />
                          </span> : null
                          }
                        </label>
                      </div>
                      <div className=" col-md-9">
                        <Field
                          name="SchedulingImpact"
                          disabled={isViewMode || !SCIAndSCIMPEnabled || values?.Region === 'Plains - South'}
                          as="select"
                          className={
                            "form-control" +
                            (errors.SchedulingImpact &&
                              touched.SchedulingImpact
                              ? " is-invalid"
                              : "")
                          }
                        >
                          <option key="" value="">
                            Select Scheduling Impact
                          </option>
                          {schedulingImpactOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}

                        </Field>
                        <ErrorMessage
                          name="SchedulingImpact"
                          component="div"
                          className="invalid-feedback"
                        />
                        <div className="otgTextCmt"> PLEASE USE CONFIDENTIALITY AND DISCRETION WHILE REVIEWING DATA.
                          DO NOT SHARE WITHOUT CONSENT FROM ASSET LOGISTICS.</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <div className="row">
                <div className=" col-md-4">
                  <div className="form-group">
                    <div className="row">
                      <div className=" col-md-3">
                        <label className="otg-formlabel">
                          Operations Impact & Mitigation Plan
                        </label>
                      </div>
                      <div className=" col-md-9">
                        <Field
                          name="OperationsImpactAndMitigationPlan"
                          type="textarea"
                          component="textarea"
                          rows="2"
                          disabled={isViewMode || !OPIAndOPIMPEnabled || values?.Region === 'Plains - South'}
                          className={
                            "form-control" +
                            (errors.OperationsImpactAndMitigationPlan &&
                              touched.OperationsImpactAndMitigationPlan
                              ? " is-invalid"
                              : "")
                          }
                        />
                        <ErrorMessage
                          name="OperationsImpactAndMitigationPlan"
                          component="div"
                          className="invalid-feedback"
                        />
                        <div className="otgTextCmt"> Please describe the impact and  describe your mitigation plan (if applicable) if you indicated an Operations Impact above.</div>
                        {!isAddMode && (
                          <label
                            className="otg-infoicon"
                            onClick={() => this.ShowCommentsHistory(values.ID, HISTORICAL_TABLE_OPS_MITIGATION_PLAN)}
                          >
                            View Previous Operations Impact and Operations Impact & Mitigation Plan
                          </label>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className=" col-md-4">
                  <div className="form-group">
                    <div className="row">
                      <div className=" col-md-3">
                        <label className="otg-formlabel">
                          Scheduling Impact & Mitigation Plan
                        </label>
                      </div>
                      <div className=" col-md-9">
                        <Field
                          name="SchedulingImpactAndMitigationPlan"
                          type="textarea"
                          component="textarea"
                          rows="2"
                          disabled={isViewMode || !SCIAndSCIMPEnabled || values?.Region === 'Plains - South'}
                          className={
                            "form-textarea form-control" +
                            (errors.SchedulingImpactAndMitigationPlan &&
                              touched.SchedulingImpactAndMitigationPlan
                              ? " is-invalid"
                              : "")
                          }
                        />
                        <ErrorMessage
                          name="SchedulingImpactAndMitigationPlan"
                          component="div"
                          className="invalid-feedback"
                        />
                        <div className="otgTextCmt"> Please describe the impact and  describe your mitigation plan if you indicated a Scheduling Impact above.</div>
                        {!isAddMode && (
                          <label
                            className="otg-infoicon"
                            onClick={() => this.ShowCommentsHistory(values.ID, HISTORICAL_TABLE_SCHEDULING_MITIGATION_PLAN)}
                          >
                            View Previous Scheduling Impact and Scheduling Impact & Mitigation Plan
                          </label>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className=" col-md-4" >
                  <div className="form-group">
                    <div className="row">
                      <div className=" col-md-3">
                        <label className="otg-formlabel">Comments</label>
                      </div>
                      <div className=" col-md-9">
                        <Field
                          name="Comments"
                          type="textarea"
                          component="textarea"
                          rows="2"
                          disabled={isViewMode}
                          className={
                            "form-textarea form-control"
                          }
                        />
                        {!isAddMode && (
                          <label className="otg-infoicon" onClick={() => this.ShowCommentsHistory(values.ID, HISTORICAL_TABLE_COMMENTS)}>View Previous Comments</label>
                        )}
                        {!isAddMode && lastAckBy && (
                          <div className="row otg-nomarginrow">
                            <label className="otg-infoicon" onClick={() => this.ShowAcknowledgementHistory(values.ID)}>View Previous Acknowledgements</label>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  {!isSameGroupUserRole && (
                    <div hidden>
                      <div className="">
                        <div className="">
                          <div className="">
                            <div className="form-group">
                              <div className="row">
                                <div className=" col-md-3">
                                  <label className="otg-formlabel">Acknowledged By<span className="otg-reqicon"><FontAwesomeIcon icon={faAsterisk} /></span></label>
                                </div>
                                <div className=" col-md-9">
                                  <Field
                                    name="AcknowledgedBy"
                                    type="text"
                                    className={
                                      "form-control" +
                                      (errors.AcknowledgedBy && touched.AcknowledgedBy
                                        ? " is-invalid"
                                        : "")
                                    }
                                  />
                                  <ErrorMessage
                                    name="AcknowledgedBy"
                                    component="div"
                                    className="invalid-feedback"
                                  />

                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <label className="otg-formlabel">Volumetrics:</label>
                </div>
              </div>
              <div className="row">
                <div className="col-md-3">
                  <div className="form-group">
                    <div className="row">
                      <div className=" col-md-3">
                        <label className="otg-formlabel">Event Type<span className="otg-reqicon"><FontAwesomeIcon icon={faAsterisk} /></span></label>
                      </div>
                      <div className=" col-md-9">
                        <Field
                          name="EventTypeId" as="select" type="text" disabled={isViewMode || !isUserFromOps || values?.Region === 'Plains - North'}
                          className={"form-control" + (errors.EventTypeId && touched.EventTypeId ? " is-invalid" : "")}
                        >
                          <option key="" value=""> Select Event Type</option>
                          {eventTypeDropdownOptions.map((option) => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                          ))}
                        </Field>
                        <ErrorMessage name="EventTypeId" component="div" className="invalid-feedback" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <div className="row">
                      <div className=" col-md-3">
                        <label className="otg-formlabel">Event Description</label>
                      </div>
                      <div className=" col-md-9">
                        <Field
                          name="EventDescription" 
                          type="textarea"
                          component="textarea"
                          rows="2"
                          className={
                            "form-textarea form-control"
                          }
                          disabled={isViewMode || !isUserFromOps || values?.Region === 'Plains - North'}
                        />
                        <ErrorMessage name="EventDescription" component="div" className="invalid-feedback" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <div className="row">
                      <div className=" col-md-3">
                        <label className="otg-formlabel">Hours Reduced Rate (h)</label>
                      </div>
                      <div className=" col-md-9">
                        <Field
                          name="HoursReducedRate" type="text" disabled={isViewMode || !isUserFromOps || values?.Region === 'Plains - North'}
                          className={"form-control" + (errors.HoursReducedRate && touched.HoursReducedRate ? " is-invalid" : "")}
                        />
                        <ErrorMessage name="HoursReducedRate" component="div" className="invalid-feedback" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <div className="row">
                      <div className=" col-md-3">
                        <label className="otg-formlabel">Reduced Rate (bbl/h)</label>
                      </div>
                      <div className=" col-md-9">
                        <Field
                          name="ReducedRate" type="text" disabled={isViewMode || !isUserFromOps || values?.Region === 'Plains - North'}
                          className={"form-control" + (errors.ReducedRate && touched.ReducedRate ? " is-invalid" : "")}
                        />
                        <ErrorMessage name="ReducedRate" component="div" className="invalid-feedback" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                {!isAddMode && lastAckBy && (lastAckBy.length > 3) && (
                  <div className=" col-md-2">
                    <div className="row">
                      <div className=" col-md-7"><label className="otg-formstaticlabel" style={{ fontWeight: 'bold' }}>Last Acknowledged By:</label></div>
                      <div className=" col-md-5"><label className="otg-formstaticlabel">{lastAckBy}</label></div>
                    </div>
                  </div>
                )}
                {!isAddMode && (
                  <>
                    <div className=" col-md-2">
                      <div className="row">
                        <div className=" col-md-5"><label className="otg-formstaticlabel" style={{ fontWeight: 'bold' }}>Created By:</label></div>
                        <div className=" col-md-7"><label className="otg-formstaticlabel">{values.CreatedBy}</label></div>
                      </div>
                    </div>
                    <div className=" col-md-2">
                      <div className="row">
                        <div className=" col-md-5"><label className="otg-formstaticlabel" style={{ fontWeight: 'bold' }}>Created On:</label></div>
                                      <div className=" col-md-7"><label className="otg-formstaticlabel">{values?.CreatedOn && values?.Region ? getDateInCSTOrMST(values.CreatedOn, values.Region) : null}</label></div>
                      </div>
                    </div>
                    <div className=" col-md-2">
                      <div className="row">
                        <div className=" col-md-5"><label className="otg-formstaticlabel" style={{ fontWeight: 'bold' }}>Updated By:</label></div>
                        <div className=" col-md-7"><label className="otg-formstaticlabel">{values?.UpdatedBy ? values.UpdatedBy : null}</label></div>
                      </div>
                    </div>
                    <div className=" col-md-2">
                      <div className="row">
                        <div className=" col-md-5"><label className="otg-formstaticlabel" style={{ fontWeight: 'bold' }}>Updated On:</label></div>
                                      <div className=" col-md-7"><label className="otg-formstaticlabel">{values?.UpdatedOn && values?.Region ? getDateInCSTOrMST(values.UpdatedOn, values.Region) : null}</label></div>
                      </div>
                    </div>
                  </>
                )}
              </div>
              <div className="form-group btnotg-pos">
                {!isReadOnlyRoleUser && (
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    hidden={isViewMode}
                    className="btn btn-primary controlotg-btns"
                  >
                    {isSubmitting && (
                      <span className="spinner-border spinner-border-sm mr-1"></span>
                    )}
                    {values.ID && isAcknowledgerRole ? "Save/Acknowledge" : "Save"}
                  </button>
                )}
                <button
                  type="cancel"
                  disabled={isSubmitting}
                  className="btn btn-primary controlotg-btns"
                  onClick={this.closeForm}
                >
                  {isSubmitting && (
                    <span className="spinner-border spinner-border-sm mr-1"></span>
                  )}
                  Cancel
                </button>
              </div>
            </Form>
          );
        }}
      </Formik>
    );
  }
  getMultiSelectLabel = ({ value }) => {
    if (value && value.some((o) => o.value === "*")) {
      return `All`;
    } else {
      return `${value.length} selected`;
    }
  }
  render() {
    const { isReadOnlyRoleUser, showSchedulingModal, showOperationsModal, isFormVisible, rowSelected,
      regions, divisions, districts, assets, selectedRegnOption,
      selectedDivOptions, selectedAstOptions, selectedDistOptions } = this.state;
      let { gridRowdata, isRowDoubleClicked } = this.state;
    const { columnDefinitions, addRowBtnText, editBtnText, exportBtnText,
      refreshBtnText, commentData } = this.props.OutageScheduleReportStore;
    const currentScreen = this.getCurrentScreen()
    const { screen: { title, name } } = currentScreen;
    let colDef = [...columnDefinitions];
    let rowData = []
    rowData = [...gridRowdata].filter(d => selectedRegnOption.some(r => d.Region.toString() == r.label));
    rowData = rowData.filter(d => {
      let division = null
      if(d.Division === ''){
        division = ''
      }else if(d.Division !== null && d.Division !== ''){
        division = d.Division.toString()
      }
      return selectedDivOptions.some(div => division == div.value)
    });
    rowData = rowData.filter(d => {
      let dists = []
        if (d.District === null || d.District === '') {
        dists.push(null)
      }else{
        dists = d?.District.split('; ')
      } 
        // Check if any value in selectedDistOptions is present in dists
        //return selectedDistOptions.some(dist => dists.includes(dist.value))
        return selectedDistOptions.some(dist => {
            const normalizedDist = dist.value === '' ? null : dist.value;
            return dists.includes(normalizedDist);
        });
    });

      //rowData = rowData.filter(d => {

      //    let facilities = []
      //    if (d.Region != "Plains - South") {
      //      if (d.Facility === null) {
      //          facilities.push(null)
      //      } else if (d.Facility === '') {
      //          facilities.push('')
      //      } else if (d.Facility !== null && d.Facility !== '') {
      //          facilities = d.Facility.split('; ')
      //      }
      //  }
      //      return selectedAstOptions.some(ast => facilities.includes(ast.value))

      //});
      rowData = rowData.filter(d => {

          let facilities = [];
          // If the Region is "North", apply the filter condition
          if (d.Region === "Plains - North") {
              if (d.Facility === null || d.Facility === '') {
                  facilities.push(null);
              } else {
                  facilities = d.Facility.split('; ');
              }

              // Check if any of the selected options match the facilities
              // Check if any value in selectedDistOptions is present in dists
              return selectedAstOptions.some(dist => {
                  const normalizedDist = dist.value === '' ? null : dist.value;
                  return facilities.includes(normalizedDist);
              });
              //return selectedAstOptions.some(ast => facilities.includes(ast.value));
          }
          
          if (this.state.isInitialLoadArray === true) {
              // If the Region is "South", include the record only if Facility is neither null nor ''
              return d.Region === "Plains - South" //&& d.Facility !== null && d.Facility !== '';
          } else {
              if (d.Facility === null || d.Facility === '') {
                  facilities.push(null);
              } else {
                  facilities = d.Facility.split('; ');
              }
              return selectedAstOptions.some(dist => {
                  const normalizedDist = dist.value === '' ? null : dist.value;
                  return facilities.includes(normalizedDist);
              });
              //return selectedAstOptions.some(ast => facilities.includes(ast.value));
          }
      });

      return (
      <>
        <div className='otg-row'>
          <h3 className="otg-title">{title}</h3>
        </div>
        {!isFormVisible && (
          <>
            <div className='otg-row'>
              <div className="otg-div-style">Region</div>
              <div className="otg-select">
                <ReactMultiSelectCheckboxes
                  options={[{ label: "All", value: "*" }, ...regions]}
                  value={selectedRegnOption} onChange={this.handleRegnSelect}
                  getDropdownButtonLabel={this.getMultiSelectLabel}
                />
              </div>
              <div className="otg-div-style">Division</div>
              <div className="otg-select">
                <ReactMultiSelectCheckboxes
                  options={[{ label: "All", value: "*" }, ...divisions]}
                  value={selectedDivOptions} onChange={this.handleDivSelect}
                  getDropdownButtonLabel={this.getMultiSelectLabel}
                />
              </div>
              <div className="otg-div-style">District</div>
              <div className="otg-select">
                <ReactMultiSelectCheckboxes
                  options={[{ label: "All", value: "*" }, ...districts]}
                  getDropdownButtonLabel={this.getMultiSelectLabel}
                  value={selectedDistOptions} onChange={this.handleDistSelect}
                />
              </div>
              <div className="otg-div-style">Asset/Location</div>
              <div className="otg-select">
                <ReactMultiSelectCheckboxes
                  options={[{ label: "All", value: "*" }, ...assets]}
                  getDropdownButtonLabel={this.getMultiSelectLabel}
                  onChange={this.handleAstSelect} value={selectedAstOptions}
                />
              </div>
            </div>
            <div className="otg-row">
              <AgGrid
                gridOptions={this.state.gridOptions} columnDefs={colDef} rowData={rowData}
                onSelectionChanged={this.onSelectionChanged} onFilterChanged={this.onFilterChanged}
                rememberGroupStateWhenNewData={true} onFirstDataRendered={this.onFirstDataRendered.bind(this)}
              />
            </div>
            <div className="otg-row otg-row-justify">
              <div className="otg-left">
                <button
                  type="button"
                  className="btn btn-primary otg-btn-text"
                  aria-expanded="false"
                  onClick={() => this.ShowOutageDueInSpecifiedDays(30, false)}
                  hidden={name != "OutageSchedule"}
                  disabled={this.state.show30DaysView}
                >
                  <FontAwesomeIcon icon={faEye} /> 30 days
                </button>
                <button
                  type="button"
                  className="btn btn-primary otg-btn-text"
                  aria-expanded="false"
                  onClick={() => this.ShowOutageDueInSpecifiedDays(60, false)}
                  hidden={name != "OutageSchedule"}
                  disabled={this.state.show60DaysView}
                >
                  <FontAwesomeIcon icon={faEye} /> 60 days
                </button>
                <button
                  type="button"
                  className="btn btn-primary otg-btn-text"
                  aria-expanded="false"
                  hidden={name != "OutageSchedule"}
                  onClick={() => this.ShowOutageDueInSpecifiedDays(180, false)}
                  disabled={this.state.show180DaysView}
                >
                  <FontAwesomeIcon icon={faEye} /> 180 days
                </button>

                <button
                  type="button"
                  className="btn btn-primary otg-btn-text"
                  aria-expanded="false"
                  onClick={() => this.ShowOutageByStatus('Discontinued', false)}
                  hidden={name != "OutageSchedule"}
                  disabled={this.state.showDiscontinuedView}
                >
                  <FontAwesomeIcon icon={faEye} /> Discontinued
                </button>
                <button
                  type="button"
                  className="btn btn-primary otg-btn-text"
                  aria-expanded="false"
                  onClick={() => this.ShowOutageByStatus('Complete', false)}
                  disabled={this.state.showCompletedView}

                >
                  <FontAwesomeIcon icon={faEye} /> Completed
                </button>
                <a
                  className="btn btn-grid bi-report-btn"
                  target="_blank"
                  rel="noopener"
                  href={window.hostName.BI_REPORT_LINK}
                >
                  <FontAwesomeIcon icon={faChartBar} /> BI Report - Gantt Chart
                </a>
              </div>
              <div className="otg-right">&nbsp;</div>
            </div>
            <div className="otg-row otg-row-justify">
              <div className="otg-left">&nbsp;</div>
              <div className="otg-right">
                <button
                  type="button"
                  className="btn btn-primary otg-btn-text"
                  aria-expanded="false"
                  disabled={isReadOnlyRoleUser}
                  onClick={this.addNewRow}
                >
                  <FontAwesomeIcon icon={faPlus} /> {addRowBtnText}
                </button>
                <button
                  type="button"
                  className="btn btn-primary otg-btn-text"
                  aria-expanded="false"
                  disabled={!rowSelected || isReadOnlyRoleUser}
                  onClick={this.editRow}
                >
                  <FontAwesomeIcon icon={faSave} /> {editBtnText}
                </button>
                <button
                  type="button"
                  className="btn btn-primary otg-btn-text"
                  aria-expanded="false"
                  onClick={this.exportToExcel}
                >
                  <FontAwesomeIcon icon={faFileExport} /> {exportBtnText}
                </button>
                <button
                  type="button"
                  className="btn btn-primary otg-btn-text"
                  aria-expanded="false"
                  onClick={() => this.refreshData(true)}
                >
                  <FontAwesomeIcon icon={faSync} /> {refreshBtnText}
                </button>
              </div>
            </div>
          </>
        )}
        {isFormVisible && title && (
          <>
          <div className="otg-formoutlay">
            {isRowDoubleClicked ? <>           
              <div className="view-msg">
                You are in read-only mode.
                If you want to edit the outage and has access to edit the outage, 
                go back to the main grid, select the outage, then select the edit button.
              </div> <br></br></>
            : null}
            {this.renderForm()}
          </div>
          </>
        )}
        <Modal show={this.state.showCommentsModel} dialogClassName="otgmodal-80w">
          <Modal.Header className="otgmodel-header">
            <Modal.Title>Comments</Modal.Title>
          </Modal.Header>
          <Modal.Body className="otgmodel-body">
            <Container>
              {this.props.OutageScheduleReportStore.commentData && this.props.OutageScheduleReportStore.commentData.map((comment) => {
                let text = new Date(comment.dateTime.toString());
                text = moment(text).format('MM/DD/YYYY h:mm a') + ' (' + comment.updatedBy + ') -';
                return (<div className="row otgmodel-row">
                  <div className="col-md-3 otgmodel-dtlbl">
                    <label>{text}</label>
                  </div>
                  <div className="col-md-9">
                    <label>{comment.comments}</label>
                  </div>
                </div>
                )
              })}
            </Container>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModal} className="otgmodel-header">
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal show={this.state.showAckModel} dialogClassName="otgmodal-smallw">
          <Modal.Header className="otgmodel-header">
            <Modal.Title>Acknowledgement History</Modal.Title>
          </Modal.Header>
          <Modal.Body className="otgmodel-body">
            <Container>
              {this.props.OutageScheduleReportStore.ackHistorytData && this.props.OutageScheduleReportStore.ackHistorytData.map((acks) => {
                let text = new Date(acks.dateTime.toString());
                text = moment(text).format('MM/DD/YYYY h:mm a');
                return (<div className="row otgmodel-row">
                  <div className="col-md-4 otgmodel-dtlbl">
                    <label>{text}</label>
                  </div>
                  <div className="col-md-4 otgmodel-dtlbl">
                    <label>{acks.updatedBy}</label>
                  </div>
                </div>
                )
              })}
            </Container>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModal} className="otgmodel-header">
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        <PrevCommentsModal
          showSchedulingModal={showSchedulingModal}
          showOperationsModal={showOperationsModal}
          commentData={commentData}
          closeModal={this.closeModal}
        />
      </>
    );
  }
  configureScreenAccess = async () => {
    const { CommonStore, OutageScheduleReportStore } = this.props;
    const jsonStringOBJ = sessionStorage.getItem('AUTH_TOKEN'); // This is the json string we stored
    const roleObj = JSON.parse(jsonStringOBJ);
    if (roleObj && roleObj.roles) {
      const userEmail = roleObj.userName;
        await OutageScheduleReportStore.getOutageLoggedUserData(userEmail, CommonStore);
        const loggedinUser = OutageScheduleReportStore.loggedUserData;
      if ((loggedinUser == null || loggedinUser == undefined) || (loggedinUser && loggedinUser.length <= 0) || (loggedinUser && loggedinUser.length > 0 && loggedinUser[0].GroupNm == userRoles.OUTAGEREADONLYROLE)) {
        this.setState({ isReadOnlyRoleUser: true, isViewMode: true });
      }
    }
  }
    setFormAccess = async (OutageRole, otgFacility, otgDistrict, otgRegion) => {
    const { CommonStore, OutageScheduleReportStore } = this.props;
    const loggedinUser = OutageScheduleReportStore.loggedUserData;
    const groupList = OutageScheduleReportStore.groupMasterData;
    let foundAllDistricts = false
    let outgRegion = null
    otgFacility = otgFacility ? otgFacility.split(';').map(item => parseInt(item)) : []
    otgDistrict = otgDistrict ? otgDistrict.split(';').map(dist => parseInt(dist)): []

    if(otgRegion === 'Plains - North'){
      outgRegion = 'N'
    }

    if(otgRegion === 'Plains - South'){
      outgRegion = 'S'
      const ids = uniq([...loggedinUser].map(item => {
        if(item.Region === outgRegion){
          return item.DistrictId
        }
      }).filter(item => item !== undefined))
      foundAllDistricts = otgDistrict?.length ? otgDistrict.every(item => ids.includes(item)) : false
    }

    const roleObj = groupList.filter(x => x.id == parseInt(OutageRole));
    this.setState({ isAcknowledgerRole: false });
    this.setState({ isViewMode: false });
    if ((loggedinUser == null || loggedinUser == undefined) || (loggedinUser && loggedinUser.length <= 0) || (loggedinUser && loggedinUser.length > 0 && loggedinUser[0].GroupNm == userRoles.OUTAGEREADONLYROLE)) {
      this.setState({ isReadOnlyRoleUser: true, isViewMode: true });
    } else {
      let userConfiguration = [] 
      if(otgRegion === 'Plains - North'){
        userConfiguration = loggedinUser.filter(x => otgFacility.includes(x.FacilityId) && (x.Region === outgRegion));
      }
      if(otgRegion === 'Plains - South' && foundAllDistricts){
        userConfiguration = loggedinUser.filter(x => otgDistrict.includes(x.DistrictId) && (x.Region === outgRegion));
      }

      const loggedUserDetail = userConfiguration && userConfiguration.length > 0 ? [...userConfiguration] : null;
      const loggedInUserGroupIds = loggedUserDetail?.length ? loggedUserDetail.map(item => parseInt(item.GroupId)) : []
      const loggedInUserGroupNames = loggedUserDetail?.length ? loggedUserDetail.map(item => item.GroupNm) : []
      if (!userConfiguration || (userConfiguration && userConfiguration.length < 1)) {
        this.setState({ isViewMode: true });
      } else if (loggedInUserGroupIds.includes(parseInt(OutageRole))) {
        this.setState({ isSameGroupUserRole: true })
      } else if (loggedInUserGroupNames.includes(userRoles.OutageControlCenter) && roleObj[0].name == userRoles.OutageControlCenter) {
        this.setState({ isSameGroupUserRole: true });

      } else if (!loggedInUserGroupIds.includes(parseInt(OutageRole))) {
        this.setState({ isSameGroupUserRole: false });
        if (loggedUserDetail?.[0]?.IsAcknowledger) {
          this.setState({ isAcknowledgerRole: true });
        }
      }
      if (loggedInUserGroupNames.includes(userRoles.OUTAGESCHEDULING) && otgRegion !== 'Plains - South') {
        this.setState({ SCIAndSCIMPEnabled: true })
      }
      if((roleObj[0].name === userRoles.OUTAGEOPSROLE || 
          roleObj[0].name === userRoles.OutageControlCenter ||
          roleObj[0].name === userRoles.OUTAGESCHEDULING) && 
        loggedInUserGroupNames.includes(userRoles.OUTAGEOPSROLE) && 
        otgRegion !== 'Plains - South'){
        this.setState({ OPIAndOPIMPEnabled: true })
      }
      if(roleObj[0].name === userRoles.OutageControlCenter && 
          loggedInUserGroupNames.includes(userRoles.OutageControlCenter) && 
        otgRegion !== 'Plains - South'){
        this.setState({ OPIAndOPIMPEnabled: true })
      }
      if(loggedInUserGroupNames.includes(userRoles.OUTAGEOPSROLE)){
        this.setState({isUserFromOps: true})
      }
    }
  }
  componentDidMount = async () => {
    this.configureScreenAccess();
    var directURLParam = this.props.computedMatch.params.profile;
    if (directURLParam != undefined) {
      const { CommonStore } = this.props;
      CommonStore.showLoaderModel();
      CommonStore.getScreens().then(() => {
        CommonStore.toggleLoader();
        this.refreshData();
      }).catch(() => {
        window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT);
        CommonStore.toggleLoader();
      })
      }
      await this.refreshData();
    };
  exportToExcel = () => {
    const { eventTypeData } = this.props.OutageScheduleReportStore
    const currentScreen = this.getCurrentScreen();
    var today = new Date();
    const formattedDate = moment(today).format('YYYYMMDDhhmmss');
    const currentSheet = currentScreen.screen.title.split(' ').join('_');
    let fileNameExcelExport = currentSheet + '_Export_All_' + formattedDate + '';
    this.state.gridOptions.api.exportDataAsExcel({
      fileName: fileNameExcelExport,
      sheetName: currentSheet,
      columnKeys: this.generateColumnsForCustomExcel(),
      processCellCallback: function (params) {
        if (params.column.colDef.cellEditor === "SmartSelect") {

          const refLookupData = currentScreen.screenColumns.find(x => x.name === params.column.colId).refLookupData;
          const selectedValue = params.value;
          if (refLookupData && refLookupData.lookupValues.values && selectedValue && refLookupData.lookupValues.values.find(x => x.value == selectedValue))
            return refLookupData.lookupValues.values.find(x => x.value == selectedValue).label;
          else if(params.column.colId!=='TypeOfWork') return null;
        }
        if (['StartDate', 'EndDate', 'CCRestartDate'].includes(params.column.colId)) {
          let text = '';
          if (params.value) {
            const region = params.node.data.Region
            const dateTime = getRegionBasedDateTime(params.value, region)
            text = moment(dateTime).format('MM/DD/YYYY');
          }
          return text;
        }
        if (params.column.colDef.cellRenderer === "booleanTextFormatter") {
          var value = params.value;
          return (value && value == true) ? "Yes" : "No";
        }
        if(params.column.colId == "EventTypeId"){
          const eventType = eventTypeData.find(item => item.ID === params.value)?.Name || params.value
          return eventType 
        }
        return params.value;
      }
    })
  };
  generateColumnsForCustomExcel() {
    const columns = this.state.gridOptions.columnApi.getAllDisplayedColumns().map(column => column.getColId());
    const columnstoExport = [...columns];
  }
  getCurrentScreen = () => {
    var screenName = this.props.path.split("/").pop();
    const { isDirectRoute } = this.state;
    if (isDirectRoute) {
      screenName = this.props.path.split("/")[1];
    }
    var currentScreen = this.props.CommonStore.screenDetails.find(
      (x) => x.screen.name === screenName
    );
    if (!currentScreen) {
      return {
        screen: { title: '', canEditRow: '', canCopyRow: '', canDeleteRow: '' },
        exportProfiles: '',
      }
    }
    return currentScreen;
  };
  loadSugession = async (target, controlName) => {
    const val = target.currentTarget.value;
    if (val.length >= 3) {
      var users = await RestEndPoint.getUsers(val);
      if (users && users.data && users.data.value && users.data.value.length > 0 && controlName == "Primary") {
        this.setState({ primaryContactSuggestions: users.data.value });
      } else if (users && users.data && users.data.value && users.data.value.length > 0 && controlName == "Secondary") {
        this.setState({ secondaryContactSuggestions: users.data.value });
      }
    }
  }

  getGridMainData = () => {
    const {
      show30DaysView, 
      show60DaysView, 
      show180DaysView,
      showDiscontinuedView,
      showCompletedView
    } = this.state
    
    const { screenColumns: columns } = this.getCurrentScreen();
    let status = ['Not Started', 'In Progress']
    if(showCompletedView){
      status = ['Complete']
    }
    if(showDiscontinuedView){
      status = ['Discontinued']
    }
    let statusDropdownOptions =
      columns?.find((x) => x.name === "Status").refLookupData?.lookupValues.values;
    let filteredStatus = statusDropdownOptions?.filter(
      wh => status.includes(wh.label)).map(wh => wh.value);
    const { rowData } = this.props.OutageScheduleReportStore;
    let gridMainData = [] 

    if(show30DaysView || show60DaysView || show180DaysView){
      let noOfDays = 0
      if(show30DaysView)
        noOfDays = 30
      if(show60DaysView)
        noOfDays = 60
      if(show180DaysView)
        noOfDays = 180

      let nextSpecifiedDays = new Date();
      nextSpecifiedDays.setDate(nextSpecifiedDays.getDate() + noOfDays);
      
      gridMainData = [...rowData].filter(rd => {
        const dateTime = getRegionBasedDateTime(rd.StartDate, rd.Region)
          return (new Date(dateTime) <= nextSpecifiedDays) && (filteredStatus.includes(rd.Status.toString()))
      });
    }else{
      gridMainData = [...rowData].filter(rd => filteredStatus?.includes(rd.Status.toString()));
    }
    return gridMainData
  }

  /**
    * Check whether all active resources(region/div/dist/asset) are present in the grid resources,
    * If anyone active resouces is not present in grid resource then, eliminate that
    * active resource from grid resource because, options of dropdowns are
    * fromed from grid resources.
  */
  getUserActiveResource = (rawResource, resourceName) => {
    let selectedResource = []
    const {
      userActiveRegions, 
      userActiveDivisions, 
      userActiveDistricts, 
      userActiveFacilities
    } = this.props.OutageScheduleReportStore

    let userActiveResource = []
    if(resourceName === 'Region'){
      userActiveResource = [...userActiveRegions]
    }
    if(resourceName === 'Division'){
      userActiveResource = [...userActiveDivisions]
    }
    if(resourceName === 'District'){
      userActiveResource = [...userActiveDistricts]
    }
    if(resourceName === 'Facility'){
      userActiveResource = [...userActiveFacilities]
      }

    rawResource.forEach(item => {
      if(userActiveResource.includes(item.value)){
        selectedResource.push(item)
      }
    })

    if(selectedResource?.length === rawResource?.length) {
      selectedResource = [{ label: 'All', value: '*' }, ...selectedResource]
    }

    return selectedResource
  }


    refreshData = async (userRefresh, fromSave) => {
        this.setState({ isInitialLoadArray: true })
    if(userRefresh){
      this.setState({
        gridRowdata: [],
        selectedRegnOption: [],
        selectedDivOptions: [],
        selectedDistOptions: [],
        selectedAstOptions: [],
        show30DaysView: false,
        show60DaysView: false,
        show180DaysView: false,
        showDiscontinuedView: false,
        showCompletedView: false
      })
    }
    let regions = [
      { label: 'Plains - South', value: 'Plains - South' },
      { label: 'Plains - North', value: 'Plains - North' }
      ]
    await this.getScreenData();
    await this.getInitialValues();
      
    let gridMainData = this.getGridMainData()

    let assets = getAllUniqAssets([...gridMainData])
    let divisions = getAllUniqDivisions([...gridMainData])
    let districts = getAllUniqDistricts([...gridMainData])

    let selectedRegnOption = this.getUserActiveResource([...regions], 'Region')
    let selectedDivOptions = this.getUserActiveResource([...divisions], 'Division')
    let selectedDistOptions = this.getUserActiveResource([...districts], 'District')
      let selectedAstOptions = this.getUserActiveResource([...assets], 'Facility')

      divisions = getAllUniqDivisionsFilterByRegion([...gridMainData], selectedRegnOption)
      districts = getAllUniqDistrictsFilterByRegionAndDivision([...gridMainData], selectedRegnOption, selectedDivOptions)
      assets = getAllUniqAssetsFilterByRegionDivisionAndDistrict([...gridMainData], selectedRegnOption, selectedDivOptions, selectedDistOptions)

    if((!selectedRegnOption?.length || !selectedDistOptions?.length || 
      !selectedDistOptions?.length || !selectedAstOptions?.length) && 
      (this.state?.gridOptions?.api)){
        this.state.gridOptions.api.setRowData([])
    }else if(this.state?.gridOptions?.api){
      this.state.gridOptions.api.setRowData([...gridMainData])
    }

    this.setState({
      gridRowdata: gridMainData,
      divisions, 
      districts, 
      assets,
      selectedRegnOption,
      selectedDivOptions,
      selectedDistOptions,
      selectedAstOptions
    });

    if (this.state.gridOptions && this.state.gridOptions.api && userRefresh) {
      this.state.gridOptions.api.deselectAll();
    }
    if (this.state.show30DaysView && fromSave !== true) {
      this.ShowOutageDueInSpecifiedDays(30, true);
    }
    if (this.state.show60DaysView && fromSave !== true) {
      this.ShowOutageDueInSpecifiedDays(60, true);
    }
    if (this.state.show180DaysView && fromSave !== true) {
      this.ShowOutageDueInSpecifiedDays(180, true);
    }
    if (this.state.showCompletedView && fromSave !== true) {
      this.ShowOutageByStatus('Complete', true);
    }
    if (this.state.showDiscontinuedView && fromSave !== true) {
      this.ShowOutageByStatus('Discontinued', true);
    }
    let filterModel = this.state.filterModel;
    if (filterModel) {
      this.state.gridOptions.api.setFilterModel(filterModel);
    }
    if (this.state.sortModel) {
      this.state.gridOptions.api.setSortModel(this.state.sortModel);
    }
  };
  ShowOutageDueInSpecifiedDays = async (noOfDays, fromRefresh) => {
    if(fromRefresh === false){
      await this.getScreenData();
      await this.getInitialValues();
      this.state.gridOptions.api.setRowData([]);
      this.setState({gridRowdata: []})
    }

    let regions = [
      { label: 'Plains - South', value: 'Plains - South' },
      { label: 'Plains - North', value: 'Plains - North' }
    ]
    const { screenColumns: columns } = this.getCurrentScreen()
    var statusDropdownOptions = columns?.find((x) => x.name === "Status")
      .refLookupData?.lookupValues.values;
    const { rowData } = this.props.OutageScheduleReportStore;
    let nextSpecifiedDays = new Date();
    nextSpecifiedDays.setDate(nextSpecifiedDays.getDate() + noOfDays);
    var filteredStatus = statusDropdownOptions.filter(wh => wh.label == "Not Started" || wh.label == "In Progress").map(wh => wh.value);
    let gridMainData = [...rowData].filter(rd => {
      const dateTime = getRegionBasedDateTime(rd.StartDate, rd.Region)
        return (new Date(dateTime) <= nextSpecifiedDays) && (filteredStatus.includes(rd.Status.toString()))
    });

    let assets = getAllUniqAssets([...gridMainData])
    let divisions = getAllUniqDivisions([...gridMainData])
    let districts = getAllUniqDistricts([...gridMainData])
    let selectedRegnOption = this.getUserActiveResource([...regions], 'Region')
    let selectedDivOptions = this.getUserActiveResource([...divisions], 'Division')
    let selectedDistOptions = this.getUserActiveResource([...districts], 'District')
    let selectedAstOptions = this.getUserActiveResource([...assets], 'Facility')

      divisions = getAllUniqDivisionsFilterByRegion([...gridMainData], selectedRegnOption)
      districts = getAllUniqDistrictsFilterByRegionAndDivision([...gridMainData], selectedRegnOption, selectedDivOptions)
      assets = getAllUniqAssetsFilterByRegionDivisionAndDistrict([...gridMainData], selectedRegnOption, selectedDivOptions, selectedDistOptions)


    if (noOfDays == 30) {
      this.state.show30DaysView = true;
      this.state.show180DaysView = this.state.show60DaysView = false;
    }
    else if (noOfDays == 60) {
      this.state.show60DaysView = true;
      this.state.show30DaysView = this.state.show180DaysView = false;
    }
    else if (noOfDays == 180) {
      this.state.show180DaysView = true;
      this.state.show30DaysView = this.state.show60DaysView = false;
    }
    this.state.showDiscontinuedView = this.state.showCompletedView = false;

    if(!selectedRegnOption?.length || !selectedDistOptions?.length || 
      !selectedDistOptions?.length || !selectedAstOptions?.length){
        this.state.gridOptions.api.setRowData([])
    }else{
      this.state.gridOptions.api.setRowData([...gridMainData]);
    }

    this.setState({
      gridRowdata: gridMainData, 
      divisions, 
      districts, 
      assets,
      selectedRegnOption,
      selectedDivOptions,
      selectedDistOptions,
      selectedAstOptions
    });
  }
  ShowOutageByStatus = async (Status, fromRefresh) => {
    if(fromRefresh === false){
      await this.getScreenData();
      await this.getInitialValues();
    }
    
    let regions = [
      { label: 'Plains - South', value: 'Plains - South' },
      { label: 'Plains - North', value: 'Plains - North' }
    ]
    const { screenColumns: columns } = this.getCurrentScreen()
    var statusDropdownOptions = columns?.find((x) => x.name === "Status")
      .refLookupData?.lookupValues.values;
    let rowData = this.props.OutageScheduleReportStore.rowData;
    var filteredStatus = statusDropdownOptions.filter(wh => wh.label == Status).map(wh => wh.value);
    let gridMainData = [...rowData].filter(rd => filteredStatus.includes(rd.Status.toString()));
    let descendingsorted = gridMainData.slice(0);
    descendingsorted.sort(function (a, b) {
      return new Date(getRegionBasedDateTime(b.EndDate, b.Region)) - new Date(getRegionBasedDateTime(a.EndDate, a.Region));
    });

    let assets = getAllUniqAssets([...gridMainData])
    let divisions = getAllUniqDivisions([...gridMainData])
    let districts = getAllUniqDistricts([...gridMainData])
    let selectedRegnOption = this.getUserActiveResource([...regions], 'Region')
    let selectedDivOptions = this.getUserActiveResource([...divisions], 'Division')
    let selectedDistOptions = this.getUserActiveResource([...districts], 'District')
    let selectedAstOptions = this.getUserActiveResource([...assets], 'Facility')

    divisions = getAllUniqDivisionsFilterByRegion([...gridMainData], selectedRegnOption)
    districts = getAllUniqDistrictsFilterByRegionAndDivision([...gridMainData], selectedRegnOption, selectedDivOptions)
    assets = getAllUniqAssetsFilterByRegionDivisionAndDistrict([...gridMainData], selectedRegnOption, selectedDivOptions, selectedDistOptions)

    if (Status == "Complete") {
      this.state.showCompletedView = true;
      this.state.showDiscontinuedView = false;
    }
    else {
      this.state.showCompletedView = false;
      this.state.showDiscontinuedView = true;
    }
    this.state.show180DaysView = this.state.show30DaysView = this.state.show60DaysView = false;
    
    if(!selectedRegnOption?.length || !selectedDistOptions?.length || 
      !selectedDistOptions?.length || !selectedAstOptions?.length){
        this.state.gridOptions.api.setRowData([])
    }else{
      this.state.gridOptions.api.setRowData(descendingsorted);
    }
    
    this.setState({
      gridRowdata: gridMainData, 
      divisions, 
      districts, 
      assets,
      selectedRegnOption,
      selectedDivOptions,
      selectedDistOptions,
      selectedAstOptions
    });
  }
  getInitialValues = async () => {
    const { OutageScheduleReportStore } = this.props;
    await OutageScheduleReportStore.getInitialValues();
  };
    getScreenData = async () => {
    const currentScreen = this.getCurrentScreen()
    const { isDirectRoute } = this.state;
    const { CommonStore, OutageScheduleReportStore } = this.props;
    const jsonStringOBJ = sessionStorage.getItem('AUTH_TOKEN'); // This is the json string we stored
    const roleObj = JSON.parse(jsonStringOBJ);
    this.setState({ isViewMode: false });
    if (currentScreen.screen.title && !isDirectRoute) {
      await OutageScheduleReportStore.getScreenData(currentScreen, CommonStore);
    }
    else if (currentScreen.screen.title && isDirectRoute) {
      var _profile = this.props.computedMatch.params.profile;
      await OutageScheduleReportStore.getAcknowledgeData(currentScreen, CommonStore, _profile);
      const { screenAcknowledgeData } = this.props.OutageScheduleReportStore;
      const editData = screenAcknowledgeData[0];
      const districtFilter = [{name: 'DIVISION', value: editData['Division']}]
      const lineSegmentFilter = [{name: 'ConsoleId', value: editData['ConsoleId']}]
      const consoleFilter = [{name: 'Active', value: 1}]

      if(editData.Region === 'Plains - South'){
        consoleFilter.push({name: 'ControlCenter', value: 'Midland'})
        await OutageScheduleReportStore.getPaaDistrictData(currentScreen, CommonStore, districtFilter)
      }
      if(editData.Region === 'Plains - North'){
        consoleFilter.push({name: 'ControlCenter', value: 'Olds'})
        await OutageScheduleReportStore.getPmcDistrictData(currentScreen, CommonStore, districtFilter)
      }
      if(editData.Region === 'Plains - South' || editData?.PinId){
        await OutageScheduleReportStore.getReasonShutdownData(currentScreen, CommonStore)
      }
      if(editData.Region === 'Plains - North' && !editData?.PinId){
        await OutageScheduleReportStore.getWorkTypeData(currentScreen, CommonStore)
      }
      await OutageScheduleReportStore.getConsoleData(currentScreen, CommonStore, consoleFilter)
      await OutageScheduleReportStore.getSegmentData(currentScreen, CommonStore, lineSegmentFilter)
      await OutageScheduleReportStore.getVolumetricEventType(currentScreen, CommonStore)
      await this.setFormAccess(editData["CreatedRole"], editData["FacilityId"], editData["DistrictId"], editData["Region"]);
      this.setState({
        rowSelected: true, editRowData: screenAcknowledgeData[0],
        previousAcknowledgement: screenAcknowledgeData[0]?.IsAcknowledged,
        isAddMode: false, isFormVisible: true,
        selectedRegnFrm: editData.Region
      });
    }
  };
  ShowAcknowledgementHistory = async (ID) => {
    const { CommonStore, OutageScheduleReportStore } = this.props;
    await OutageScheduleReportStore.getAcknowledgeHistoryData(
      CommonStore,
      ID
    );
    const ackData = outageScheduleReportStore.ackHistorytData;
    if (ackData && ackData.length > 0) {
      this.setState({ showAckModel: true });
    }
  }
  ShowCommentsHistory = async (ID, tableName) => {
    const { CommonStore, OutageScheduleReportStore } = this.props;
    await OutageScheduleReportStore.getCommentsData(
      CommonStore,
      ID,
      tableName
    );
    const commentsData = outageScheduleReportStore.commentData;
    if (commentsData && commentsData?.length && tableName === HISTORICAL_TABLE_SCHEDULING_MITIGATION_PLAN) {
      this.setState({ showSchedulingModal: true });
    }
    if (commentsData && commentsData?.length && tableName === HISTORICAL_TABLE_OPS_MITIGATION_PLAN) {
      this.setState({ showOperationsModal: true });
    }
    if (commentsData && commentsData.length && tableName === HISTORICAL_TABLE_COMMENTS) {
      this.setState({ showCommentsModel: true })
    }
  }
  closeModal = async (ID) => {
    this.setState({
      showCommentsModel: false,
      showAckModel: false,
      showSchedulingModal: false,
      showOperationsModal: false
    });
  }

  convertToSemiColonSeparatedIfArray = (data) => {
    return Array.isArray(data) ? data.join(";") : data
}

  convertStrFieldsToNumberWhenUpdate = (data) => {
    const {editRowData} = this.state
    const { OutageScheduleReportStore } = this.props
    const { 
      consoleData, 
      segmentData, 
      paaDistrictData, 
      pmcDistrictData, 
      pmcAssetData, 
      paaAssetData,
      workTypeData,
      reasonShutdownData
    } = OutageScheduleReportStore

    const fieldsTobeConverted = [
      'Console',
      'District',
      'Division',
      'PipeSegment',
      'Facility',
      'TypeOfWork'
    ]

      fieldsTobeConverted.forEach(item => {
      // Console
      if(item === 'Console' && consoleData?.length === 0){
        data.ConsoleId = editRowData['ConsoleId']
      }
      if(item === 'Console' && consoleData?.length){
        data.ConsoleId = consoleData.find(ele => ele.Title === data[item])?.ID || ''
      }
      // PipeSegment
      if(item === 'PipeSegment' && segmentData?.length === 0){
          data.PipeSegmentId = this.convertToSemiColonSeparatedIfArray(editRowData['PipeSegmentId'])
      }
        if (item === 'PipeSegment' && segmentData?.length) {
            data.PipeSegmentId = this.convertToSemiColonSeparatedIfArray(segmentData.map(ele => {
                if (typeof data[item] === 'string' && data[item].split(';').map(item => item.trim()).includes(ele.Description.trim())) {
                    return ele.ID
                }
                else if (Array.isArray(data[item]) && data[item].map(item => item.trim()).includes(ele.Description.trim())) {
                    return ele.ID
                }
            }).filter(ele => ![undefined, null].includes(ele)) || '')
        }
      // District
      if(item === 'District' && data.Region === 'Plains - South' && paaDistrictData?.length === 0){
          data.DistrictId = this.convertToSemiColonSeparatedIfArray(editRowData['DistrictId'])
      }
      if(item === 'District' && data.Region === 'Plains - North' && pmcDistrictData?.length === 0){
          data.DistrictId = this.convertToSemiColonSeparatedIfArray(editRowData['DistrictId'])
      }
          if (item === 'District' && data.Region === 'Plains - South' && paaDistrictData?.length) {
              data.DistrictId = this.convertToSemiColonSeparatedIfArray(paaDistrictData.map(ele => {
                  if (typeof data[item] === 'string' && data[item].split(';').map(item => item.trim()).includes(ele.Title.trim())) {
                      return ele.Id
                  }
                  else if (Array.isArray(data[item]) && data[item].map(item => item.trim()).includes(ele.Title.trim())) {
                      return ele.Id
                  }
              }).filter(ele => ![undefined, null].includes(ele)) || '')
          }
      if(item === 'District' && data.Region === 'Plains - North' && pmcDistrictData?.length){
          data.DistrictId = this.convertToSemiColonSeparatedIfArray(pmcDistrictData.find(ele => ele.Title === data[item])?.Id || '')
      }
      // Implement for Facility
      if(item === 'Facility' && data.Region === 'Plains - South' && paaAssetData?.length === 0){
          data.Facility = this.convertToSemiColonSeparatedIfArray(editRowData['FacilityId'])
      }
      if(item === 'Facility' && data.Region === 'Plains - North' && pmcAssetData?.length === 0){
          data.Facility = this.convertToSemiColonSeparatedIfArray(editRowData['FacilityId'])
      }
          if (item === 'Facility' && data.Region === 'Plains - South' && paaAssetData?.length) {
              data.Facility = paaAssetData.map(ele => {
                  if (Array.isArray(data[item]) && data[item].map(item => item.trim()).includes(ele.TITLE.trim())) {
                          return ele.ID
                  } else if (typeof data[item] === 'string' && data[item].split(';').map(item => item.trim()).includes(ele.TITLE.trim())) {
                          return ele.ID
                  }
              }).filter(ele => ![undefined, null].includes(ele)) || ''

              data.Facility = this.convertToSemiColonSeparatedIfArray(data.Facility);
          }
      if(item === 'Facility' && data.Region === 'Plains - North' && pmcAssetData?.length){
          data.Facility = this.convertToSemiColonSeparatedIfArray(pmcAssetData.find(ele => ele.ASSET === data[item])?.ID || '')
      }
      // Implement for Primary contact
      if(data?.Region === 'S' && data.PrimaryContact?.length){
          data.PrimaryContact = this.convertToSemiColonSeparatedIfArray(data.PrimaryContact)
      }
      // Implement for Type of work
      if(item === 'TypeOfWork' && (data.Region === 'Plains - South' || data?.PinId) && reasonShutdownData?.length){
        if(data[item]){
          data.TypeOfWork = reasonShutdownData.find(ele => `${ele.TITLE} - ${ele.MAIN}` === data[item])?.ID || ''
        }
      }
      if(item === 'TypeOfWork' && data.Region === 'Plains - North' && workTypeData?.length && !data?.PinId){
        data.TypeOfWork = workTypeData.find(ele => ele.NAME === data[item])?.ID || ''
      }
      if(data.TypeOfWork === '' || data.TypeOfWork === null){
        data.TypeOfWork = editRowData['TypeOfWorkId']
      }

      if(['PipeSegment', 'Console', 'District', 'Division'].includes(item)){
        delete data[item]
      }
    })

    data.Region = data.Region === 'Plains - North' ? 'N' : 'S'
    return data
  }

  convertStrFieldsToNumber = (data, saveMode) => {
    const fieldsTobeConverted = [
      'Console',
      'District',
      'Division',
      'PipeSegment',
    ]

    fieldsTobeConverted.forEach(item => {
      if(item === 'Console'){
        data.ConsoleId = Number(data[item])
      }
      if(item === 'District'){
          const districtIds = data.Region === 'N' ? Number(data[item]) : this.convertToSemiColonSeparatedIfArray(data[item])
          data.DistrictId = districtIds
      }
      if(item === 'PipeSegment'){
          data.PipeSegmentId = data.Region === 'N' ? '' : this.convertToSemiColonSeparatedIfArray(data[item])
      }

      delete data[item]
    })

    if(data?.Region === 'S' && data.Facility?.length){
        data.Facility = this.convertToSemiColonSeparatedIfArray(data.Facility)
    }
    if(data?.Region === 'S' && data.PrimaryContact?.length){
        data.PrimaryContact = this.convertToSemiColonSeparatedIfArray(data.PrimaryContact)
    }

    return data
  }


  saveScreenData = async (ScreenData) => {
    let isAcknowledgeUpdate = false;
    let mandatoryFieldsChanged = false;

    const currentScreen = this.getCurrentScreen()
    const { CommonStore, OutageScheduleReportStore } = this.props;
    const { isAddMode, previousAcknowledgement, editRowData } = this.state;
    const saveMode = isAddMode ? "Save" : "Update";

    ScreenData.StartDate = getDateTimeWithoutUTCOffset(ScreenData.StartDate, 'StartDate')
    ScreenData.EndDate = getDateTimeWithoutUTCOffset(ScreenData.EndDate, 'EndDate')
    ScreenData.CCRestartDate = getDateTimeWithoutUTCOffset(ScreenData.CCRestartDate, 'CCRestartDate')

    if(saveMode === 'Save'){
      if(ScreenData?.Region === 'Plains - North'){
        ScreenData.Region = 'N'
        ScreenData = this.convertStrFieldsToNumber(ScreenData, saveMode)
      }
      if(ScreenData?.Region === 'Plains - South'){
        ScreenData.Region = 'S'
        ScreenData = this.convertStrFieldsToNumber(ScreenData, saveMode)
      }
        }

    if (saveMode == "Update") {
      var facilityChanged = editRowData.Facility != ScreenData.Facility;
      ScreenData = this.convertStrFieldsToNumberWhenUpdate(ScreenData)

       // ScreenData.Facility = typeof ScreenData.Facility === 'string' ? ScreenData.Facility.replace(/,/g, ';') : ScreenData.Facility;
       // ScreenData.DistrictId = typeof ScreenData.DistrictId === 'string' ? ScreenData.DistrictId.replace(/,/g, ';') : ScreenData.DistrictId;
       // ScreenData.PipeSegmentId = typeof ScreenData.PipeSegmentId === 'string' ? ScreenData.PipeSegmentId.replace(/,/g, ';') : ScreenData.PipeSegmentId;

      // Match StartDate submitted in form vs coming in grid data
      var screenStartDate = new Date(ScreenData.StartDate);
      let savedStartDate = getRegionBasedDateTime(editRowData.StartDate, editRowData.Region)
      savedStartDate = getDateTimeWithoutUTCOffset(savedStartDate, 'StartDate')
      savedStartDate = new Date(savedStartDate)

      // Match EndDate submitted in form vs coming in grid data
      var screenEndDate = ScreenData.EndDate ? new Date(ScreenData.EndDate) : null;
      let savedEndDate = editRowData?.EndDate ? getRegionBasedDateTime(editRowData.EndDate, editRowData.Region) : null
      if(savedEndDate){
        savedEndDate = getDateTimeWithoutUTCOffset(savedEndDate, 'EndDate')
        savedEndDate = new Date(savedEndDate)
      }

      const startDateChanged = screenStartDate.toUTCString() == savedStartDate.toUTCString();
      const endDateChanged = screenEndDate?.toUTCString() != savedEndDate?.toUTCString();
      mandatoryFieldsChanged = (!startDateChanged || facilityChanged || endDateChanged); // don't ask confirmation in case of mandatory fields change
    }

    const { screen, screenColumns: columns } = currentScreen;
    let plannedText = "Planned";
    if (screen.name !== "OutageSchedule") {
      plannedText = "UnPlanned";
    }
    ScreenData["OutageType"] = plannedText;
    const jsonStringOBJ = sessionStorage.getItem('AUTH_TOKEN'); // This is the json string we stored
    const roleObj = JSON.parse(jsonStringOBJ);
    if (roleObj && roleObj.roles) {
      const roles = roleObj.roles.join();
      const isOutageCommunicationOpsRole = (roles.indexOf(userRoles.OUTAGECOMMUNICATIONOPSROLE) !== -1);
      const isOutageCommunicationRWUser = (roles.indexOf(userRoles.OUTAGECOMMUNICATIONUSERS) !== -1);
      this.populateAuditFields(ScreenData, isAddMode, isOutageCommunicationOpsRole, isOutageCommunicationRWUser);
    }
    const screenData = {};
    const dataVal = Object.assign(screenData, ScreenData);

    if (previousAcknowledgement != true && (ScreenData["IsAcknowledged"] == "1" || ScreenData["IsAcknowledged"] == true)) {
      isAcknowledgeUpdate = true;
    }
    let isPreAcknowledged = false;
    if (previousAcknowledgement == true && ScreenData["CurrentAcknowledged"] == true) {
      isPreAcknowledged = true;
    }
    if ((isAcknowledgeUpdate || mandatoryFieldsChanged) && saveMode == "Update") {
      await OutageScheduleReportStore.saveScreenData(
        screenData, CommonStore, currentScreen, saveMode, true, isAcknowledgeUpdate
      );
    } else if (isPreAcknowledged) {
      await OutageScheduleReportStore.saveScreenData(
        screenData, CommonStore, currentScreen, saveMode, false
      );
    }
    else if (saveMode == "Update") {
      confirmAlert({
        title: 'Email on this update',
        message: 'Do you want to send email to users for this update?',
        buttons: [
          {
            label: 'Yes',
            onClick: async () => {
              await OutageScheduleReportStore.saveScreenData(
                screenData, CommonStore, currentScreen, saveMode, true, isAcknowledgeUpdate
              ); await this.refreshData(null, true);
            }
          },
          {
            label: 'No',
            onClick: async () => {
              await OutageScheduleReportStore.saveScreenData(
                screenData, CommonStore, currentScreen, saveMode, false, isAcknowledgeUpdate
              ); await this.refreshData(null, true);
            }
          }
        ]
      });
    } else {
      await OutageScheduleReportStore.saveScreenData(
        screenData, CommonStore, currentScreen, saveMode
      );
    }
    this.setState({ isAddMode: false });
    this.closeForm();
    await this.refreshData(null, true);

  };
  populateAuditFields(data, isAddRow, isOutageCommunicationOpsRole, isOutageCommunicationRWUser) {
    const currentUser = RestEndPoint.getCurrentUserName();
    const currentUserEmail = RestEndPoint.getCurrentUserEmail();
    const { isSameGroupUserRole, isAcknowledgerRole } = this.state;
    //moment.tz.setDefault('America/Edmonton');
    const { CommonStore, OutageScheduleReportStore } = this.props;
    const loggedUser = OutageScheduleReportStore.loggedUserData[0];
    if (!isSameGroupUserRole && isAcknowledgerRole && !isAddRow) {
      data['IsAcknowledged'] = true;
      data['CurrentAcknowledged'] = true;
    }
    var currentTime = moment(new Date());
    if ('CreatedBy' in data && isAddRow) {
      data['CreatedBy'] = currentUser;
    }
    if ('UpdatedBy' in data) {
      data['UpdatedBy'] = currentUser;
    }
    if ('CreatedOn' in data && isAddRow) {
      data['CreatedOn'] = currentTime;
    }
    if ('CreatedEmail' in data && isAddRow) {
      data['CreatedEmail'] = currentUserEmail;
    }
    if ('CreatedRole' in data && isAddRow) {
      data['CreatedRole'] = loggedUser.GroupId;
    }
    if ('UpdatedOn' in data) {
      data['UpdatedOn'] = currentTime;
    }

    if ('IsActive' in data && isAddRow) {
      data['IsActive'] = 1;
    }

    if ('AdvanceNotice' in data && isAddRow) {
      const startDate = moment(data['StartDate']);
      const createdDate = moment(data['CreatedOn']);
      data['AdvanceNotice'] = startDate.diff(createdDate, 'days');
    }
  }
  onCellValueChanged = (e) => {
    if (e.newValue !== null && e.oldValue != e.newValue) {
      this.state.gridOptions.api.refreshCells();
    } else {
      e.node.setDataValue(e.colDef.field, e.oldValue);
      this.state.gridOptions.api.refreshCells();
    }
  }
  onFirstDataRendered(params) {
    // if (this.state.show30DaysView) {
    //   this.ShowOutageDueInSpecifiedDays(30);
    // }
    // if (this.state.show60DaysView) {
    //   this.ShowOutageDueInSpecifiedDays(60);
    // }
    // if (this.state.show180DaysView) {
    //   this.ShowOutageDueInSpecifiedDays(180);
    // }
    // if (this.state.showDiscontinuedView) {
    //   this.ShowOutageByStatus('Discontinued');
    // }
    // if (this.state.showCompletedView) {
    //   this.ShowOutageByStatus('Complete');
    // }
    let filterModel = this.state.filterModel;

    if (filterModel) {
      this.state.gridOptions.api.setFilterModel(filterModel);
    }
    if (this.state.sortModel) {
      this.state.gridOptions.api.setSortModel(this.state.sortModel);
    }
  }
}

export default OutageScheduleReport;
